var items = {
  "block.minecraft.acacia_button": "Buttuna tal-Akaċja",
  "block.minecraft.acacia_door": "Bieb tal-Akaċja",
  "block.minecraft.acacia_fence": "Ċint tal-Akaċja",
  "block.minecraft.acacia_fence_gate": "Grada tal-Akaċja",
  "block.minecraft.acacia_hanging_sign": "Tabella Mdendla tal-Akaċja",
  "block.minecraft.acacia_leaves": "Weraq tal-Akaċja",
  "block.minecraft.acacia_log": "Zokk tal-Akaċja",
  "block.minecraft.acacia_planks": "Twavel tal-Akaċja",
  "block.minecraft.acacia_pressure_plate": "Pjanċa tal-Akaċja",
  "block.minecraft.acacia_sapling": "Żgħar tal-Akaċja",
  "block.minecraft.acacia_shelf": "Xkaffa tal-Akaċja",
  "block.minecraft.acacia_sign": "Tabella tal-Akaċja",
  "block.minecraft.acacia_slab": "Ċangun tal-Akaċja",
  "block.minecraft.acacia_stairs": "Taraġ tal-Akaċja",
  "block.minecraft.acacia_trapdoor": "Bokkaport tal-Akaċja",
  "block.minecraft.acacia_wall_hanging_sign": "Tabella tal-Ħajt Imdendla tal-Akaċja",
  "block.minecraft.acacia_wall_sign": "Tabella tal-Akaċja mal-Ħajt",
  "block.minecraft.acacia_wood": "Injam tal-Akaċja",
  "block.minecraft.activator_rail": "Linji Jattivaw",
  "block.minecraft.air": "Arja",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Blokk ta ' Amethyst",
  "block.minecraft.amethyst_cluster": "Għanqud tal-Ametista",
  "block.minecraft.ancient_debris": "Tifrik Antik",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Ċangun tal-Andesit",
  "block.minecraft.andesite_stairs": "Taraġ tal-Andesit",
  "block.minecraft.andesite_wall": "Ħajt tal-Andesit",
  "block.minecraft.anvil": "Inkwina",
  "block.minecraft.attached_melon_stem": "Zokk tad-Dulliegħa Mqabbad",
  "block.minecraft.attached_pumpkin_stem": "Zokk tal-Qargħa Ħamra Mqabbad",
  "block.minecraft.azalea": "Ażalea",
  "block.minecraft.azalea_leaves": "Weraq tal-Ażalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Bambù",
  "block.minecraft.bamboo_block": "Blokka tal-Bambù",
  "block.minecraft.bamboo_button": "Buttuna tal-Bambù",
  "block.minecraft.bamboo_door": "Bieb tal-Bambù",
  "block.minecraft.bamboo_fence": "Ilqugħ tal-Bambù",
  "block.minecraft.bamboo_fence_gate": "Xatba tal-Bambù",
  "block.minecraft.bamboo_hanging_sign": "Tabella Mdendla tal-Bambù",
  "block.minecraft.bamboo_mosaic": "Mużajk tal-Bambù",
  "block.minecraft.bamboo_mosaic_slab": "Ċangun tal-Mużajk tal-Bambù",
  "block.minecraft.bamboo_mosaic_stairs": "Taraġ tal-Mużajk tal-Bambù",
  "block.minecraft.bamboo_planks": "Twavel tal-Bambù",
  "block.minecraft.bamboo_pressure_plate": "Pjanċa tal-Bambù",
  "block.minecraft.bamboo_sapling": "Rimja tal-bambu",
  "block.minecraft.bamboo_shelf": "Xkaffa tal-Bambù",
  "block.minecraft.bamboo_sign": "Tabella tal-Bambù",
  "block.minecraft.bamboo_slab": "Ċangun tal-Bambù",
  "block.minecraft.bamboo_stairs": "Taraġ tal-Bambù",
  "block.minecraft.bamboo_trapdoor": "Bokkaport tal-Bambù",
  "block.minecraft.bamboo_wall_hanging_sign": "Tabella tal-Ħajt Mdendla tal-Bambù",
  "block.minecraft.bamboo_wall_sign": "Tabella tal-Ħajt tal-Bambù",
  "block.minecraft.banner.base.black": "Qasam Kompletament Iswed",
  "block.minecraft.banner.base.blue": "Qasam Blu Kompletament",
  "block.minecraft.banner.base.brown": "Qasam Kompletament Kannella",
  "block.minecraft.banner.base.cyan": "Qasam Kompletament Iżraq",
  "block.minecraft.banner.base.gray": "Qasam Kompletament Griż",
  "block.minecraft.banner.base.green": "Qasam kompletament aħdar",
  "block.minecraft.banner.base.light_blue": "Kamp Blu Ċar kompletament",
  "block.minecraft.banner.base.light_gray": "Qasam Griż Ħafif Kompletament",
  "block.minecraft.banner.base.lime": "Qasam tal-Ġir Kompletament",
  "block.minecraft.banner.base.magenta": "Qasam maġenta għal Kollox",
  "block.minecraft.banner.base.orange": "Qasam Kompletament Oranġjo",
  "block.minecraft.banner.base.pink": "Qasam Roża kompletament",
  "block.minecraft.banner.base.purple": "Qasam Vjola Kompletament",
  "block.minecraft.banner.base.red": "Qasam Aħmar Kompletament",
  "block.minecraft.banner.base.white": "Qasam Kompletament Abjad",
  "block.minecraft.banner.base.yellow": "Qasam Isfar għal kollox",
  "block.minecraft.banner.border.black": "Bordur Iswed",
  "block.minecraft.banner.border.blue": "Bordur Blu",
  "block.minecraft.banner.border.brown": "Bordur Kannella",
  "block.minecraft.banner.border.cyan": "Bordur Iżraq",
  "block.minecraft.banner.border.gray": "Bordur Griż",
  "block.minecraft.banner.border.green": "Bordur Aħdar",
  "block.minecraft.banner.border.light_blue": "Bordur Ikħal",
  "block.minecraft.banner.border.light_gray": "Bordur Ixheb",
  "block.minecraft.banner.border.lime": "Bordur Limetta",
  "block.minecraft.banner.border.magenta": "Bordur Maġenta",
  "block.minecraft.banner.border.orange": "Bordur Oranġjo",
  "block.minecraft.banner.border.pink": "Bordur Roża",
  "block.minecraft.banner.border.purple": "Bordur Vjola",
  "block.minecraft.banner.border.red": "Bordur Aħmar",
  "block.minecraft.banner.border.white": "Bordur Abjad",
  "block.minecraft.banner.border.yellow": "Bordur Isfar",
  "block.minecraft.banner.bricks.black": "Black Field Masoned",
  "block.minecraft.banner.bricks.blue": "Blue Field Masoned",
  "block.minecraft.banner.bricks.brown": "Brown Field Masoned",
  "block.minecraft.banner.bricks.cyan": "Cyan Field Masoned",
  "block.minecraft.banner.bricks.gray": "Gray Field Masoned",
  "block.minecraft.banner.bricks.green": "Green Field Masoned",
  "block.minecraft.banner.bricks.light_blue": "Light Blue Field Masoned",
  "block.minecraft.banner.bricks.light_gray": "Light Gray Field Masoned",
  "block.minecraft.banner.bricks.lime": "Lime Field Masoned",
  "block.minecraft.banner.bricks.magenta": "Magenta Field Masoned",
  "block.minecraft.banner.bricks.orange": "Orange Field Masoned",
  "block.minecraft.banner.bricks.pink": "Pink Field Masoned",
  "block.minecraft.banner.bricks.purple": "Purple Field Masoned",
  "block.minecraft.banner.bricks.red": "Red Field Masoned",
  "block.minecraft.banner.bricks.white": "White Field Masoned",
  "block.minecraft.banner.bricks.yellow": "Yellow Field Masoned",
  "block.minecraft.banner.circle.black": "Black Roundel",
  "block.minecraft.banner.circle.blue": "Blue Roundel",
  "block.minecraft.banner.circle.brown": "Brown Roundel",
  "block.minecraft.banner.circle.cyan": "Cyan Roundel",
  "block.minecraft.banner.circle.gray": "Gray Roundel",
  "block.minecraft.banner.circle.green": "Green Roundel",
  "block.minecraft.banner.circle.light_blue": "Light Blue Roundel",
  "block.minecraft.banner.circle.light_gray": "Light Gray Roundel",
  "block.minecraft.banner.circle.lime": "Lime Roundel",
  "block.minecraft.banner.circle.magenta": "Magenta Roundel",
  "block.minecraft.banner.circle.orange": "Orange Roundel",
  "block.minecraft.banner.circle.pink": "Pink Roundel",
  "block.minecraft.banner.circle.purple": "Purple Roundel",
  "block.minecraft.banner.circle.red": "Red Roundel",
  "block.minecraft.banner.circle.white": "White Roundel",
  "block.minecraft.banner.circle.yellow": "Yellow Roundel",
  "block.minecraft.banner.creeper.black": "Black Creeper Charge",
  "block.minecraft.banner.creeper.blue": "ċarġ ta creeper blu",
  "block.minecraft.banner.creeper.brown": "ċarġ ta creeper kannella",
  "block.minecraft.banner.creeper.cyan": "Cyan Creeper Charge",
  "block.minecraft.banner.creeper.gray": "ċarġ ta creeper griz",
  "block.minecraft.banner.creeper.green": "ċarġ ta creeper aħdar",
  "block.minecraft.banner.creeper.light_blue": "ċarġ ta creeper blue car",
  "block.minecraft.banner.creeper.light_gray": "ċarġ ta creeper griz car",
  "block.minecraft.banner.creeper.lime": "ċarġ ta creeper lumicella",
  "block.minecraft.banner.creeper.magenta": "ċarġ ta creeper magenta",
  "block.minecraft.banner.creeper.orange": "ċarġ ta creeper orangjo",
  "block.minecraft.banner.creeper.pink": "ċarġ ta creeper roza",
  "block.minecraft.banner.creeper.purple": "ċarġ ta creeper viola",
  "block.minecraft.banner.creeper.red": "Red Creeper Charge",
  "block.minecraft.banner.creeper.white": "ċarġ ta creeper abjad",
  "block.minecraft.banner.creeper.yellow": "ċarġ ta creeper isfar",
  "block.minecraft.banner.cross.black": "Salib ta' Sant' Andrija iswed",
  "block.minecraft.banner.cross.blue": "Salib ta' Sant' Andrija ikħal",
  "block.minecraft.banner.cross.brown": "Salib ta' Sant' Andrija kannella",
  "block.minecraft.banner.cross.cyan": "Salib ta' Sant' Andrija ċilesti",
  "block.minecraft.banner.cross.gray": "Salib ta' Sant' Andrija griż",
  "block.minecraft.banner.cross.green": "Salib ta' Sant' Andrija aħdar",
  "block.minecraft.banner.cross.light_blue": "Salib ta' Sant' Andrija ikħal ċar",
  "block.minecraft.banner.cross.light_gray": "Salib ta' Sant' Andrija griż ċar",
  "block.minecraft.banner.cross.lime": "Salib ta' Sant' Andrija aħdar ċar",
  "block.minecraft.banner.cross.magenta": "Salib ta' Sant' Andrija vjola ċar",
  "block.minecraft.banner.cross.orange": "Salib ta' Sant' Andrija orangjo",
  "block.minecraft.banner.cross.pink": "Salib ta' Sant' Andrija roża",
  "block.minecraft.banner.cross.purple": "Salib ta' Sant' Andrija vjola",
  "block.minecraft.banner.cross.red": "Salib ta' Sant' Andrija aħmar",
  "block.minecraft.banner.cross.white": "Salib ta' Sant' Andrija abjad",
  "block.minecraft.banner.cross.yellow": "Salib ta' Sant' Andrija isfar",
  "block.minecraft.banner.curly_border.black": "Black Bordure Indented",
  "block.minecraft.banner.curly_border.blue": "Blue Bordure Indented",
  "block.minecraft.banner.curly_border.brown": "Brown Bordure Indented",
  "block.minecraft.banner.curly_border.cyan": "Cyan Bordure Indented",
  "block.minecraft.banner.curly_border.gray": "Gray Bordure Indented",
  "block.minecraft.banner.curly_border.green": "Green Bordure Indented",
  "block.minecraft.banner.curly_border.light_blue": "Light Blue Bordure Indented",
  "block.minecraft.banner.curly_border.light_gray": "Light Gray Bordure Indented",
  "block.minecraft.banner.curly_border.lime": "Lime Bordure Indented",
  "block.minecraft.banner.curly_border.magenta": "Magenta Bordure Indented",
  "block.minecraft.banner.curly_border.orange": "Orange Bordure Indented",
  "block.minecraft.banner.curly_border.pink": "Pink Bordure Indented",
  "block.minecraft.banner.curly_border.purple": "Purple Bordure Indented",
  "block.minecraft.banner.curly_border.red": "Red Bordure Indented",
  "block.minecraft.banner.curly_border.white": "White Bordure Indented",
  "block.minecraft.banner.curly_border.yellow": "Yellow Bordure Indented",
  "block.minecraft.banner.diagonal_left.black": "Black Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Gray Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Green Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Light Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Light Gray Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lime Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Orange Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pink Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Purple Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.red": "Red Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.white": "White Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Per Bend Sinister",
  "block.minecraft.banner.diagonal_right.black": "Black Per Bend",
  "block.minecraft.banner.diagonal_right.blue": "Blue Per Bend",
  "block.minecraft.banner.diagonal_right.brown": "Brown Per Bend",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Per Bend",
  "block.minecraft.banner.diagonal_right.gray": "Gray Per Bend",
  "block.minecraft.banner.diagonal_right.green": "Green Per Bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Light Blue Per Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Light Gray Per Bend",
  "block.minecraft.banner.diagonal_right.lime": "Lime Per Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Per Bend",
  "block.minecraft.banner.diagonal_right.orange": "Orange Per Bend",
  "block.minecraft.banner.diagonal_right.pink": "Pink Per Bend",
  "block.minecraft.banner.diagonal_right.purple": "Purple Per Bend",
  "block.minecraft.banner.diagonal_right.red": "Red Per Bend",
  "block.minecraft.banner.diagonal_right.white": "White Per Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow Per Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Black Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Gray Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.green": "Green Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light Blue Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Light Gray Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.lime": "Lime Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.purple": "Purple Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Red Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.white": "White Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Per Bend Inverted",
  "block.minecraft.banner.diagonal_up_right.black": "Black Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.gray": "Gray Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.green": "Green Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Pink Per Bend Sinister",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Light Gray Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.lime": "Lime Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.pink": "Pink Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.purple": "Purple Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.red": "Red Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.white": "White Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow Per Bend Sinister Inverted",
  "block.minecraft.banner.flow.black": "il-Belliegħa Sewda",
  "block.minecraft.banner.flow.blue": "Il-Belliegħa Kaħla",
  "block.minecraft.banner.flow.brown": "il-Belliegħa Kannella",
  "block.minecraft.banner.flow.cyan": "Il-Belliegħa Ċjan",
  "block.minecraft.banner.flow.gray": "Il-Belliegħa Griża",
  "block.minecraft.banner.flow.green": "Il-Belliegħa Ħadra",
  "block.minecraft.banner.flow.light_blue": "Il-Belliegħa Żerqa",
  "block.minecraft.banner.flow.light_gray": "Il-Belliegħa Rmidija",
  "block.minecraft.banner.flow.lime": "Il-Belliegħa Lumiċellija",
  "block.minecraft.banner.flow.magenta": "Il-Belliegħa Maġenta",
  "block.minecraft.banner.flow.orange": "Il-Belliegħa Oranġjo",
  "block.minecraft.banner.flow.pink": "Il-Belliegħa Roża",
  "block.minecraft.banner.flow.purple": "Il-Belliegħa Vjola",
  "block.minecraft.banner.flow.red": "Il-Belliegħa Ħamra",
  "block.minecraft.banner.flow.white": "Il-Belliegħa Bajda",
  "block.minecraft.banner.flow.yellow": "Il-Belliegħa Safra",
  "block.minecraft.banner.flower.black": "Black Flower Charge",
  "block.minecraft.banner.flower.blue": "Blue Flower Charge",
  "block.minecraft.banner.flower.brown": "Brown Flower Charge",
  "block.minecraft.banner.flower.cyan": "Cyan Flower Charge",
  "block.minecraft.banner.flower.gray": "Gray Flower Charge",
  "block.minecraft.banner.flower.green": "Green Flower Charge",
  "block.minecraft.banner.flower.light_blue": "Light Blue Flower Charge",
  "block.minecraft.banner.flower.light_gray": "Light Gray Flower Charge",
  "block.minecraft.banner.flower.lime": "Lime Flower Charge",
  "block.minecraft.banner.flower.magenta": "Magenta Flower Charge",
  "block.minecraft.banner.flower.orange": "Orange Flower Charge",
  "block.minecraft.banner.flower.pink": "Pink Flower Charge",
  "block.minecraft.banner.flower.purple": "Purple Flower Charge",
  "block.minecraft.banner.flower.red": "Red Flower Charge",
  "block.minecraft.banner.flower.white": "White Flower Charge",
  "block.minecraft.banner.flower.yellow": "Yellow Flower Charge",
  "block.minecraft.banner.globe.black": "Globu iswed",
  "block.minecraft.banner.globe.blue": "Globu blu",
  "block.minecraft.banner.globe.brown": "Globu kannella",
  "block.minecraft.banner.globe.cyan": "Dinja ta ' cyan",
  "block.minecraft.banner.globe.gray": "Dinja griża",
  "block.minecraft.banner.globe.green": "Globu aħdar",
  "block.minecraft.banner.globe.light_blue": "Globu blu ċar",
  "block.minecraft.banner.globe.light_gray": "Gloy dinja",
  "block.minecraft.banner.globe.lime": "Globu tal-lajm",
  "block.minecraft.banner.globe.magenta": "Dinja ta ' magenta",
  "block.minecraft.banner.globe.orange": "Globu oranġjo",
  "block.minecraft.banner.globe.pink": "Globu roża",
  "block.minecraft.banner.globe.purple": "Globu vjola",
  "block.minecraft.banner.globe.red": "Globu aħmar",
  "block.minecraft.banner.globe.white": "Globu abjad",
  "block.minecraft.banner.globe.yellow": "Globu isfar",
  "block.minecraft.banner.gradient.black": "Black Gradient",
  "block.minecraft.banner.gradient.blue": "Blue Gradient",
  "block.minecraft.banner.gradient.brown": "Brown Gradient",
  "block.minecraft.banner.gradient.cyan": "Cyan Gradient",
  "block.minecraft.banner.gradient.gray": "Gray Gradient",
  "block.minecraft.banner.gradient.green": "Green Gradient",
  "block.minecraft.banner.gradient.light_blue": "Light Blue Gradient",
  "block.minecraft.banner.gradient.light_gray": "Light Gray Gradient",
  "block.minecraft.banner.gradient.lime": "Lime Gradient",
  "block.minecraft.banner.gradient.magenta": "Magenta Gradient",
  "block.minecraft.banner.gradient.orange": "Orange Gradient",
  "block.minecraft.banner.gradient.pink": "Pink Gradient",
  "block.minecraft.banner.gradient.purple": "Purple Gradient",
  "block.minecraft.banner.gradient.red": "Red Gradient",
  "block.minecraft.banner.gradient.white": "White Gradient",
  "block.minecraft.banner.gradient.yellow": "Yellow Gradient",
  "block.minecraft.banner.gradient_up.black": "Black Base Gradient",
  "block.minecraft.banner.gradient_up.blue": "Blue Base Gradient",
  "block.minecraft.banner.gradient_up.brown": "Brown Base Gradient",
  "block.minecraft.banner.gradient_up.cyan": "Cyan Base Gradient",
  "block.minecraft.banner.gradient_up.gray": "Gray Base Gradient",
  "block.minecraft.banner.gradient_up.green": "Green Base Gradient",
  "block.minecraft.banner.gradient_up.light_blue": "Light Blue Base Gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Light Gray Base Gradient",
  "block.minecraft.banner.gradient_up.lime": "Lime Base Gradient",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Base Gradient",
  "block.minecraft.banner.gradient_up.orange": "Orange Base Gradient",
  "block.minecraft.banner.gradient_up.pink": "Pink Base Gradient",
  "block.minecraft.banner.gradient_up.purple": "Purple Base Gradient",
  "block.minecraft.banner.gradient_up.red": "Red Base Gradient",
  "block.minecraft.banner.gradient_up.white": "White Base Gradient",
  "block.minecraft.banner.gradient_up.yellow": "Yellow Base Gradient",
  "block.minecraft.banner.guster.black": "Il-Buffurej Iswed",
  "block.minecraft.banner.guster.blue": "Il-Buffurej Ikħal",
  "block.minecraft.banner.guster.brown": "Il-Buffurej Kannella",
  "block.minecraft.banner.guster.cyan": "Il-Buffurej Ċjan",
  "block.minecraft.banner.guster.gray": "Il-Buffurej Griż",
  "block.minecraft.banner.guster.green": "Il-Buffurej Aħdar",
  "block.minecraft.banner.guster.light_blue": "Il-Buffurej Iżraq",
  "block.minecraft.banner.guster.light_gray": "Il-Buffurej Rmiedi",
  "block.minecraft.banner.guster.lime": "Il-Buffurej Lumiċelli",
  "block.minecraft.banner.guster.magenta": "Il-Buffurej Maġenta",
  "block.minecraft.banner.guster.orange": "Il-Buffurej Oranġjo",
  "block.minecraft.banner.guster.pink": "Il-Buffurej Roża",
  "block.minecraft.banner.guster.purple": "Il-Buffurej Vjola",
  "block.minecraft.banner.guster.red": "Il-Buffurej Aħmar",
  "block.minecraft.banner.guster.white": "Il-Buffurej Abjad",
  "block.minecraft.banner.guster.yellow": "Il-Buffurej Isfar",
  "block.minecraft.banner.half_horizontal.black": "Black Per Fess",
  "block.minecraft.banner.half_horizontal.blue": "Blue Per Fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown Per Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan Per Fess",
  "block.minecraft.banner.half_horizontal.gray": "Gray Per Fess",
  "block.minecraft.banner.half_horizontal.green": "Green Per Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Light Blue Per Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Light Gray Per Fess",
  "block.minecraft.banner.half_horizontal.lime": "Lime Per Fess",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Per Fess",
  "block.minecraft.banner.half_horizontal.orange": "Orange Per Fess",
  "block.minecraft.banner.half_horizontal.pink": "Pink Per Fess",
  "block.minecraft.banner.half_horizontal.purple": "Purple Per Fess",
  "block.minecraft.banner.half_horizontal.red": "Red Per Fess",
  "block.minecraft.banner.half_horizontal.white": "White Per Fess",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blue Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Gray Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Light Blue Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Light Gray Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lime Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purple Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "White Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow Per Fess Inverted",
  "block.minecraft.banner.half_vertical.black": "Black Per Pale",
  "block.minecraft.banner.half_vertical.blue": "Blue Per Pale",
  "block.minecraft.banner.half_vertical.brown": "Brown Per Pale",
  "block.minecraft.banner.half_vertical.cyan": "Cyan Per Pale",
  "block.minecraft.banner.half_vertical.gray": "Gray Per Pale",
  "block.minecraft.banner.half_vertical.green": "Green Per Pale",
  "block.minecraft.banner.half_vertical.light_blue": "Light Blue Per Pale",
  "block.minecraft.banner.half_vertical.light_gray": "Light Gray Per Pale",
  "block.minecraft.banner.half_vertical.lime": "Lime Per Pale",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Per Pale",
  "block.minecraft.banner.half_vertical.orange": "Orange Per Pale",
  "block.minecraft.banner.half_vertical.pink": "Pink Per Pale",
  "block.minecraft.banner.half_vertical.purple": "Purple Per Pale",
  "block.minecraft.banner.half_vertical.red": "Red Per Pale",
  "block.minecraft.banner.half_vertical.white": "White Per Pale",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Per Pale",
  "block.minecraft.banner.half_vertical_right.black": "Black Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.blue": "Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.brown": "Brown Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.gray": "Gray Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.green": "Green Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Light Gray Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.lime": "Lime Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.orange": "Orange Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Pink Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.purple": "Purple Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.red": "Red Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.white": "White Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow Per Pale Inverted",
  "block.minecraft.banner.mojang.black": "Ħaġa sewda",
  "block.minecraft.banner.mojang.blue": "Ħaġa blu",
  "block.minecraft.banner.mojang.brown": "Ħaġa kannella",
  "block.minecraft.banner.mojang.cyan": "ħaġa cyan",
  "block.minecraft.banner.mojang.gray": "Ħaġa griża",
  "block.minecraft.banner.mojang.green": "Ħaġa ħadra",
  "block.minecraft.banner.mojang.light_blue": "Ħaġa blue car",
  "block.minecraft.banner.mojang.light_gray": "Ħaġa griż car",
  "block.minecraft.banner.mojang.lime": "Ħaġa lumicella",
  "block.minecraft.banner.mojang.magenta": "Magenta Thing",
  "block.minecraft.banner.mojang.orange": "Orange Thing",
  "block.minecraft.banner.mojang.pink": "Ħaġa roża",
  "block.minecraft.banner.mojang.purple": "Ħaġa vjola",
  "block.minecraft.banner.mojang.red": "Ħaġa ħamra",
  "block.minecraft.banner.mojang.white": "White Thing",
  "block.minecraft.banner.mojang.yellow": "Ħaġa safra",
  "block.minecraft.banner.piglin.black": "Geddum iswed",
  "block.minecraft.banner.piglin.blue": "Geddum blu",
  "block.minecraft.banner.piglin.brown": "Geddum kannella",
  "block.minecraft.banner.piglin.cyan": "Geddum cyan",
  "block.minecraft.banner.piglin.gray": "Geddum griż",
  "block.minecraft.banner.piglin.green": "Geddum gdid",
  "block.minecraft.banner.piglin.light_blue": "Geddum blu ċar",
  "block.minecraft.banner.piglin.light_gray": "Geddum griż ċar",
  "block.minecraft.banner.piglin.lime": "Geddum ġir",
  "block.minecraft.banner.piglin.magenta": "Geddum maġenta",
  "block.minecraft.banner.piglin.orange": "Geddum oranġjo",
  "block.minecraft.banner.piglin.pink": "Geddum roża",
  "block.minecraft.banner.piglin.purple": "Geddum vjola",
  "block.minecraft.banner.piglin.red": "Geddum aħmar",
  "block.minecraft.banner.piglin.white": "Geddum abjad",
  "block.minecraft.banner.piglin.yellow": "Geddum isfar",
  "block.minecraft.banner.rhombus.black": "Black Lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue Lozenge",
  "block.minecraft.banner.rhombus.brown": "Brown Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Cyan Lozenge",
  "block.minecraft.banner.rhombus.gray": "Gray Lozenge",
  "block.minecraft.banner.rhombus.green": "Green Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Light Blue Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Light Gray Lozenge",
  "block.minecraft.banner.rhombus.lime": "Lime Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Magenta Lozenge",
  "block.minecraft.banner.rhombus.orange": "Orange Lozenge",
  "block.minecraft.banner.rhombus.pink": "Pink Lozenge",
  "block.minecraft.banner.rhombus.purple": "Purple Lozenge",
  "block.minecraft.banner.rhombus.red": "Red Lozenge",
  "block.minecraft.banner.rhombus.white": "White Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow Lozenge",
  "block.minecraft.banner.skull.black": "Black Skull Charge",
  "block.minecraft.banner.skull.blue": "Blue Skull Charge",
  "block.minecraft.banner.skull.brown": "Brown Skull Charge",
  "block.minecraft.banner.skull.cyan": "Cyan Skull Charge",
  "block.minecraft.banner.skull.gray": "Gray Skull Charge",
  "block.minecraft.banner.skull.green": "Green Skull Charge",
  "block.minecraft.banner.skull.light_blue": "Light Blue Skull Charge",
  "block.minecraft.banner.skull.light_gray": "Light Gray Skull Charge",
  "block.minecraft.banner.skull.lime": "Lime Skull Charge",
  "block.minecraft.banner.skull.magenta": "Magenta Skull Charge",
  "block.minecraft.banner.skull.orange": "Orange Skull Charge",
  "block.minecraft.banner.skull.pink": "Pink Skull Charge",
  "block.minecraft.banner.skull.purple": "Purple Skull Charge",
  "block.minecraft.banner.skull.red": "Red Skull Charge",
  "block.minecraft.banner.skull.white": "White Skull Charge",
  "block.minecraft.banner.skull.yellow": "Yellow Skull Charge",
  "block.minecraft.banner.small_stripes.black": "Black Paly",
  "block.minecraft.banner.small_stripes.blue": "Blue Paly",
  "block.minecraft.banner.small_stripes.brown": "Brown Paly",
  "block.minecraft.banner.small_stripes.cyan": "Cyan Paly",
  "block.minecraft.banner.small_stripes.gray": "Strixxa griża vertikali",
  "block.minecraft.banner.small_stripes.green": "Green Paly",
  "block.minecraft.banner.small_stripes.light_blue": "Strixxa ikħal ċar vertikali",
  "block.minecraft.banner.small_stripes.light_gray": "Light Gray Paly",
  "block.minecraft.banner.small_stripes.lime": "Strixxa aħdar ċar vertikali",
  "block.minecraft.banner.small_stripes.magenta": "Strixxa vjola ċar vertikali",
  "block.minecraft.banner.small_stripes.orange": "Strixxa orangjo vertikali",
  "block.minecraft.banner.small_stripes.pink": "Strixxa roża vertikali",
  "block.minecraft.banner.small_stripes.purple": "Purple Paly",
  "block.minecraft.banner.small_stripes.red": "Red Paly",
  "block.minecraft.banner.small_stripes.white": "Strixxa bajda vertikali",
  "block.minecraft.banner.small_stripes.yellow": "Strixxa safra vertikali",
  "block.minecraft.banner.square_bottom_left.black": "Kantuniera fuq ix-xellug b'bażi sewda",
  "block.minecraft.banner.square_bottom_left.blue": "Kantuniera fuq ix-xellug b'bażi kaħlija",
  "block.minecraft.banner.square_bottom_left.brown": "Kantuniera fuq ix-xellug b'bażi kannella",
  "block.minecraft.banner.square_bottom_left.cyan": "Kantuniera fuq ix-xellug b'bażi ċilesti",
  "block.minecraft.banner.square_bottom_left.gray": "Kantuniera fuq ix-xellug b'bażi griż",
  "block.minecraft.banner.square_bottom_left.green": "Kantuniera fuq ix-xellug b'bażi ħadra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Kantuniera fuq ix-xellug b'bażi ikħal ċar",
  "block.minecraft.banner.square_bottom_left.light_gray": "Kantuniera fuq ix-xellug b'bażi griż ċar",
  "block.minecraft.banner.square_bottom_left.lime": "Kantuniera fuq ix-xellug b'bażi aħdar ċar",
  "block.minecraft.banner.square_bottom_left.magenta": "Kantuniera fuq ix-xellug b'bażi vjola ċar",
  "block.minecraft.banner.square_bottom_left.orange": "Kantuniera fuq ix-xellug b'bażi oranġjo",
  "block.minecraft.banner.square_bottom_left.pink": "Kantuniera fuq ix-xellug b'bażi roza",
  "block.minecraft.banner.square_bottom_left.purple": "Kantuniera fuq ix-xellug b'bażi vjola",
  "block.minecraft.banner.square_bottom_left.red": "Kantuniera fuq ix-xellug b'bażi ħamra",
  "block.minecraft.banner.square_bottom_left.white": "Kantuniera fuq ix-xellug b'bażi bajda",
  "block.minecraft.banner.square_bottom_left.yellow": "Kantuniera fuq ix-xellug b'bażi isfar",
  "block.minecraft.banner.square_bottom_right.black": "Kantuniera fuq il-lemien b'bażi sewda",
  "block.minecraft.banner.square_bottom_right.blue": "Kantuniera fuq ix xellug b'bażi ikħal",
  "block.minecraft.banner.square_bottom_right.brown": "Kantuniera fuq il-lemin b'bażi kannella",
  "block.minecraft.banner.square_bottom_right.cyan": "Kantuniera fuq il-lemin b'bażi ċilesti",
  "block.minecraft.banner.square_bottom_right.gray": "Kantuniera fuq il-lemin b'bażi griż",
  "block.minecraft.banner.square_bottom_right.green": "Kantuniera fuq il-lemin b'bażi aħdar",
  "block.minecraft.banner.square_bottom_right.light_blue": "Kantuniera fuq il-lemin b'bażi ikħar ċar",
  "block.minecraft.banner.square_bottom_right.light_gray": "Kantuniera fuq ix xellug b'bażi griż ċar",
  "block.minecraft.banner.square_bottom_right.lime": "Kantuniera fuq il-lemin b'bażi aħdar ċar",
  "block.minecraft.banner.square_bottom_right.magenta": "Kantuniera fuq il-lemin b'bażi vjola ċar",
  "block.minecraft.banner.square_bottom_right.orange": "Kantuniera fuq il-lemin b'bażi oranġjo",
  "block.minecraft.banner.square_bottom_right.pink": "Kantuniera fuq ix xellug b'bażi roża",
  "block.minecraft.banner.square_bottom_right.purple": "Kantuniera fuq il-lemin b'bażi vjola",
  "block.minecraft.banner.square_bottom_right.red": "Kantuniera fuq il-lemien b'bażi ħamra",
  "block.minecraft.banner.square_bottom_right.white": "Kantuniera fuq il-lemin b'bażi abjad",
  "block.minecraft.banner.square_bottom_right.yellow": "Kantuniera fuq il-lemin b'bażi isfar",
  "block.minecraft.banner.square_top_left.black": "Kantuniera ta' fuq ix-xellug sewda",
  "block.minecraft.banner.square_top_left.blue": "Kantuniera ta' fuq ix-xellug ikħal",
  "block.minecraft.banner.square_top_left.brown": "Kantuniera ta' fuq ix-xellug kannella",
  "block.minecraft.banner.square_top_left.cyan": "Kantuniera ta' fuq ix-xellug ċilesti",
  "block.minecraft.banner.square_top_left.gray": "Kantuniera ta' fuq ix-xellug griż",
  "block.minecraft.banner.square_top_left.green": "Kantuniera ta' fuq ix-xellug ħadra",
  "block.minecraft.banner.square_top_left.light_blue": "Kantuniera ta' fuq ix-xellug ikħal ċar",
  "block.minecraft.banner.square_top_left.light_gray": "Kantuniera ta' fuq ix-xellug griż ċar",
  "block.minecraft.banner.square_top_left.lime": "Kantuniera ta' fuq ix-xellug aħdar ċar",
  "block.minecraft.banner.square_top_left.magenta": "Kantuniera ta' fuq ix-xellug vjola ċar",
  "block.minecraft.banner.square_top_left.orange": "Kantuniera ta' fuq ix-xellug orangjo",
  "block.minecraft.banner.square_top_left.pink": "Kantuniera ta' fuq ix-xellug roża",
  "block.minecraft.banner.square_top_left.purple": "Kantuniera ta' fuq ix-xellug vjola",
  "block.minecraft.banner.square_top_left.red": "Kantuniera ta' fuq ix-xellug ħamra",
  "block.minecraft.banner.square_top_left.white": "Kantuniera ta' fuq ix-xellug bajda",
  "block.minecraft.banner.square_top_left.yellow": "Kantuniera ta' fuq ix-xellug isfar",
  "block.minecraft.banner.square_top_right.black": "Kantuniera ta' fuq il-lemin sewda",
  "block.minecraft.banner.square_top_right.blue": "Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.brown": "Brown Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.cyan": "Cyan Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.gray": "Gray Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.green": "Green Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_blue": "Light Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_gray": "Light Gray Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.lime": "Lime Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.orange": "Orange Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.pink": "Pink Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.purple": "Purple Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.red": "Kantuniera ta' fuq ix-xellug ħamra",
  "block.minecraft.banner.square_top_right.white": "White Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.yellow": "Yellow Chief Sinister Canton",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Blue Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Cyan Cross",
  "block.minecraft.banner.straight_cross.gray": "Gray Cross",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Light Blue Cross",
  "block.minecraft.banner.straight_cross.light_gray": "Light Gray Cross",
  "block.minecraft.banner.straight_cross.lime": "Lime Cross",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Cross",
  "block.minecraft.banner.straight_cross.orange": "Orange Cross",
  "block.minecraft.banner.straight_cross.pink": "Pink Cross",
  "block.minecraft.banner.straight_cross.purple": "Purple Cross",
  "block.minecraft.banner.straight_cross.red": "Red Cross",
  "block.minecraft.banner.straight_cross.white": "White Cross",
  "block.minecraft.banner.straight_cross.yellow": "Yellow Cross",
  "block.minecraft.banner.stripe_bottom.black": "Bażi Iswed",
  "block.minecraft.banner.stripe_bottom.blue": "Bażi Blu",
  "block.minecraft.banner.stripe_bottom.brown": "Bażi Kannella",
  "block.minecraft.banner.stripe_bottom.cyan": "Bażi Iżraq",
  "block.minecraft.banner.stripe_bottom.gray": "Bażi Griż",
  "block.minecraft.banner.stripe_bottom.green": "Bażi Aħdar",
  "block.minecraft.banner.stripe_bottom.light_blue": "Bażi Ikħal",
  "block.minecraft.banner.stripe_bottom.light_gray": "Bażi Ixheb",
  "block.minecraft.banner.stripe_bottom.lime": "Bażi Limett",
  "block.minecraft.banner.stripe_bottom.magenta": "Bażi Maġenta",
  "block.minecraft.banner.stripe_bottom.orange": "Bażi Oranġjo",
  "block.minecraft.banner.stripe_bottom.pink": "Bażi Roża",
  "block.minecraft.banner.stripe_bottom.purple": "Bażi Vjola",
  "block.minecraft.banner.stripe_bottom.red": "Bażi Aħmar",
  "block.minecraft.banner.stripe_bottom.white": "Bażi Abjad",
  "block.minecraft.banner.stripe_bottom.yellow": "Bażi Isfar",
  "block.minecraft.banner.stripe_center.black": "Strixxa Sewda",
  "block.minecraft.banner.stripe_center.blue": "Strixxa kaħlija",
  "block.minecraft.banner.stripe_center.brown": "Strixxa kannella",
  "block.minecraft.banner.stripe_center.cyan": "Strixxa ċilesti",
  "block.minecraft.banner.stripe_center.gray": "Strixxa griża",
  "block.minecraft.banner.stripe_center.green": "Strixxa ħadra",
  "block.minecraft.banner.stripe_center.light_blue": "Strixxa ikħal ċar",
  "block.minecraft.banner.stripe_center.light_gray": "Strixxa griż ċar",
  "block.minecraft.banner.stripe_center.lime": "Strixxa aħdar ċar",
  "block.minecraft.banner.stripe_center.magenta": "Strixxa vjola ċar",
  "block.minecraft.banner.stripe_center.orange": "Strixxa orangjo",
  "block.minecraft.banner.stripe_center.pink": "Strixxa roża",
  "block.minecraft.banner.stripe_center.purple": "Strixxa vjola",
  "block.minecraft.banner.stripe_center.red": "Strixxa ħamra",
  "block.minecraft.banner.stripe_center.white": "Strixxa bajda",
  "block.minecraft.banner.stripe_center.yellow": "Strixxa safra",
  "block.minecraft.banner.stripe_downleft.black": "Black Bend Sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blue Bend Sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Brown Bend Sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan Bend Sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Gray Bend Sinister",
  "block.minecraft.banner.stripe_downleft.green": "Green Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Light Blue Bend Sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light Gray Bend Sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Lime Bend Sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Bend Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Orange Bend Sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Pink Bend Sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Purple Bend Sinister",
  "block.minecraft.banner.stripe_downleft.red": "Red Bend Sinister",
  "block.minecraft.banner.stripe_downleft.white": "White Bend Sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow Bend Sinister",
  "block.minecraft.banner.stripe_downright.black": "Black Bend",
  "block.minecraft.banner.stripe_downright.blue": "Blue Bend",
  "block.minecraft.banner.stripe_downright.brown": "Brown Bend",
  "block.minecraft.banner.stripe_downright.cyan": "Cyan Bend",
  "block.minecraft.banner.stripe_downright.gray": "Gray Bend",
  "block.minecraft.banner.stripe_downright.green": "Green Bend",
  "block.minecraft.banner.stripe_downright.light_blue": "Light Blue Bend",
  "block.minecraft.banner.stripe_downright.light_gray": "Light Gray Bend",
  "block.minecraft.banner.stripe_downright.lime": "Lime Bend",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Bend",
  "block.minecraft.banner.stripe_downright.orange": "Orange Bend",
  "block.minecraft.banner.stripe_downright.pink": "Pink Bend",
  "block.minecraft.banner.stripe_downright.purple": "Purple Bend",
  "block.minecraft.banner.stripe_downright.red": "Red Bend",
  "block.minecraft.banner.stripe_downright.white": "White Bend",
  "block.minecraft.banner.stripe_downright.yellow": "Yellow Bend",
  "block.minecraft.banner.stripe_left.black": "Black Pale Dexter",
  "block.minecraft.banner.stripe_left.blue": "Strixxa kaħlija fuq ix-xellug",
  "block.minecraft.banner.stripe_left.brown": "Brown Pale Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Strixxa cilesti fuq ix-xellug",
  "block.minecraft.banner.stripe_left.gray": "Strixxa griż fuq ix-xellug",
  "block.minecraft.banner.stripe_left.green": "Green Pale Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Strixxa ikħal ċar fuq ix-xellug",
  "block.minecraft.banner.stripe_left.light_gray": "Strixxa griż ċar fuq ix-xellug",
  "block.minecraft.banner.stripe_left.lime": "Strixxa aħdar ċar fuq ix-xellug",
  "block.minecraft.banner.stripe_left.magenta": "Strixxa vjola ċar fuq ix-xellug",
  "block.minecraft.banner.stripe_left.orange": "Strixxa orangjo fuq ix-xellug",
  "block.minecraft.banner.stripe_left.pink": "Strixxa roża fuq ix-xellug",
  "block.minecraft.banner.stripe_left.purple": "Strixxa vjola fuq ix-xellug",
  "block.minecraft.banner.stripe_left.red": "Red Pale Dexter",
  "block.minecraft.banner.stripe_left.white": "Strixxa bajda fuq ix-xellug",
  "block.minecraft.banner.stripe_left.yellow": "Strixxa safra fuq ix-xellug",
  "block.minecraft.banner.stripe_middle.black": "Strixxa sewda fin-nofs",
  "block.minecraft.banner.stripe_middle.blue": "Strixxa kaħlija fin-nofs",
  "block.minecraft.banner.stripe_middle.brown": "Strixxa kannella fin-nofs",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan Fess",
  "block.minecraft.banner.stripe_middle.gray": "Gray Fess",
  "block.minecraft.banner.stripe_middle.green": "Strixxa ħadra fin-nofs",
  "block.minecraft.banner.stripe_middle.light_blue": "Light Blue Fess",
  "block.minecraft.banner.stripe_middle.light_gray": "Light Gray Fess",
  "block.minecraft.banner.stripe_middle.lime": "Lime Fess",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Fess",
  "block.minecraft.banner.stripe_middle.orange": "Orange Fess",
  "block.minecraft.banner.stripe_middle.pink": "Pink Fess",
  "block.minecraft.banner.stripe_middle.purple": "Strixxa vjola fin-nofs",
  "block.minecraft.banner.stripe_middle.red": "Strixxa ħamra fin-nofs",
  "block.minecraft.banner.stripe_middle.white": "White Fess",
  "block.minecraft.banner.stripe_middle.yellow": "Yellow Fess",
  "block.minecraft.banner.stripe_right.black": "Strixxa sewda fuq il-lemin",
  "block.minecraft.banner.stripe_right.blue": "Strixxa kaħlija fuq il-lemin",
  "block.minecraft.banner.stripe_right.brown": "Strixxa kannella fuq il-lemin",
  "block.minecraft.banner.stripe_right.cyan": "Strixxa ċilesti fuq il-lemin",
  "block.minecraft.banner.stripe_right.gray": "Strixxa griża fuq il-lemin",
  "block.minecraft.banner.stripe_right.green": "Strixxa ħadra fuq il-lemin",
  "block.minecraft.banner.stripe_right.light_blue": "Strixxa ikħal ċar fuq il-lemin",
  "block.minecraft.banner.stripe_right.light_gray": "Strixxa griż ċar fuq il-lemin",
  "block.minecraft.banner.stripe_right.lime": "Strixxa aħdar ċar fuq il-lemin",
  "block.minecraft.banner.stripe_right.magenta": "Strixxa vjola ċar fuq il-lemin",
  "block.minecraft.banner.stripe_right.orange": "Strixxa orangjo fuq il-lemin",
  "block.minecraft.banner.stripe_right.pink": "Strixxa roża fuq il-lemin",
  "block.minecraft.banner.stripe_right.purple": "Strixxa vjola fuq il-lemin",
  "block.minecraft.banner.stripe_right.red": "Strixxa ħamra fuq il-lemin",
  "block.minecraft.banner.stripe_right.white": "Strixxa cajda fuq il-lemin",
  "block.minecraft.banner.stripe_right.yellow": "Strixxa safra fuq il-lemin",
  "block.minecraft.banner.stripe_top.black": "Kap tal-iswed",
  "block.minecraft.banner.stripe_top.blue": "Kap blu",
  "block.minecraft.banner.stripe_top.brown": "Kap kannella",
  "block.minecraft.banner.stripe_top.cyan": "Kap ta ' cyan",
  "block.minecraft.banner.stripe_top.gray": "Kap tal-Gray",
  "block.minecraft.banner.stripe_top.green": "Kap aħdar",
  "block.minecraft.banner.stripe_top.light_blue": "Kap blu ċar",
  "block.minecraft.banner.stripe_top.light_gray": "Kap tal-Gray ħafif",
  "block.minecraft.banner.stripe_top.lime": "Kap tal-ġir",
  "block.minecraft.banner.stripe_top.magenta": "Kap ta ' magenta",
  "block.minecraft.banner.stripe_top.orange": "Kap tal-larin ġ",
  "block.minecraft.banner.stripe_top.pink": "Kap roża",
  "block.minecraft.banner.stripe_top.purple": "Kap vjola",
  "block.minecraft.banner.stripe_top.red": "Kap aħmar",
  "block.minecraft.banner.stripe_top.white": "Kap abjad",
  "block.minecraft.banner.stripe_top.yellow": "Kap isfar",
  "block.minecraft.banner.triangle_bottom.black": "Chevron iswed",
  "block.minecraft.banner.triangle_bottom.blue": "Chevron ikħal",
  "block.minecraft.banner.triangle_bottom.brown": "Chevron kannella",
  "block.minecraft.banner.triangle_bottom.cyan": "Chevron ċilesti",
  "block.minecraft.banner.triangle_bottom.gray": "Chevron griż",
  "block.minecraft.banner.triangle_bottom.green": "Chevron aħdar",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chevron ikħal ċar",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chevron griż ċar",
  "block.minecraft.banner.triangle_bottom.lime": "Chevron aħdar ċar",
  "block.minecraft.banner.triangle_bottom.magenta": "Chevron vjola ċar",
  "block.minecraft.banner.triangle_bottom.orange": "Chevron orangjo",
  "block.minecraft.banner.triangle_bottom.pink": "Chevron roża",
  "block.minecraft.banner.triangle_bottom.purple": "Chevron vjola",
  "block.minecraft.banner.triangle_bottom.red": "Chevron aħmar",
  "block.minecraft.banner.triangle_bottom.white": "Chevron abjad",
  "block.minecraft.banner.triangle_bottom.yellow": "Chevron isfar",
  "block.minecraft.banner.triangle_top.black": "Chevron meqlub iswed",
  "block.minecraft.banner.triangle_top.blue": "Chevron meqlub ikħal",
  "block.minecraft.banner.triangle_top.brown": "Chevron meqlub kannella",
  "block.minecraft.banner.triangle_top.cyan": "Chevron meqlub ċilesti",
  "block.minecraft.banner.triangle_top.gray": "Chevron meqlub griż",
  "block.minecraft.banner.triangle_top.green": "Chevron meqlub aħdar",
  "block.minecraft.banner.triangle_top.light_blue": "Light Blue Inverted Chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Chevron meqlub griż ċar",
  "block.minecraft.banner.triangle_top.lime": "Lime Inverted Chevron",
  "block.minecraft.banner.triangle_top.magenta": "Magenta Inverted Chevron",
  "block.minecraft.banner.triangle_top.orange": "Orange Inverted Chevron",
  "block.minecraft.banner.triangle_top.pink": "Chevron meqlub roża",
  "block.minecraft.banner.triangle_top.purple": "Chevron meqlub vjola",
  "block.minecraft.banner.triangle_top.red": "Chevron meqlub aħmar",
  "block.minecraft.banner.triangle_top.white": "White Inverted Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Yellow Inverted Chevron",
  "block.minecraft.banner.triangles_bottom.black": "Black Base Indented",
  "block.minecraft.banner.triangles_bottom.blue": "Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.brown": "Brown Base Indented",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyan Base Indented",
  "block.minecraft.banner.triangles_bottom.gray": "Gray Base Indented",
  "block.minecraft.banner.triangles_bottom.green": "Green Base Indented",
  "block.minecraft.banner.triangles_bottom.light_blue": "Light Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.light_gray": "Light Gray Base Indented",
  "block.minecraft.banner.triangles_bottom.lime": "Lime Base Indented",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Base Indented",
  "block.minecraft.banner.triangles_bottom.orange": "Orange Base Indented",
  "block.minecraft.banner.triangles_bottom.pink": "Pink Base Indented",
  "block.minecraft.banner.triangles_bottom.purple": "Purple Base Indented",
  "block.minecraft.banner.triangles_bottom.red": "Red Base Indented",
  "block.minecraft.banner.triangles_bottom.white": "White Base Indented",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow Base Indented",
  "block.minecraft.banner.triangles_top.black": "Black Chief Indented",
  "block.minecraft.banner.triangles_top.blue": "Blue Chief Indented",
  "block.minecraft.banner.triangles_top.brown": "Brown Chief Indented",
  "block.minecraft.banner.triangles_top.cyan": "Cyan Chief Indented",
  "block.minecraft.banner.triangles_top.gray": "Gray Chief Indented",
  "block.minecraft.banner.triangles_top.green": "Green Chief Indented",
  "block.minecraft.banner.triangles_top.light_blue": "Light Blue Chief Indented",
  "block.minecraft.banner.triangles_top.light_gray": "Light Gray Chief Indented",
  "block.minecraft.banner.triangles_top.lime": "Lime Chief Indented",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Chief Indented",
  "block.minecraft.banner.triangles_top.orange": "Orange Chief Indented",
  "block.minecraft.banner.triangles_top.pink": "Pink Chief Indented",
  "block.minecraft.banner.triangles_top.purple": "Purple Chief Indented",
  "block.minecraft.banner.triangles_top.red": "Red Chief Indented",
  "block.minecraft.banner.triangles_top.white": "White Chief Indented",
  "block.minecraft.banner.triangles_top.yellow": "Yellow Chief Indented",
  "block.minecraft.barrel": "Bittija",
  "block.minecraft.barrier": "Blokka Inviżibli",
  "block.minecraft.basalt": "Bażalt",
  "block.minecraft.beacon": "Lanterna",
  "block.minecraft.beacon.primary": "Poter Prinċipali",
  "block.minecraft.beacon.secondary": "Poter Sekondarju",
  "block.minecraft.bed.no_sleep": "Inti tista' torqod billejl jew waqt maltempati biss",
  "block.minecraft.bed.not_safe": "Ma tistax tistrieħ għalissa; hemm bhejjem fil-qrib",
  "block.minecraft.bed.obstructed": "Dis-Sodda hija ostakolata",
  "block.minecraft.bed.occupied": "Din is-sodda hija okkupata",
  "block.minecraft.bed.too_far_away": "Ma tistax tistrieħ għalissa; is-sodda hija ‘l bogħod wisq",
  "block.minecraft.bedrock": "Blat",
  "block.minecraft.bee_nest": "Bejta tan-Naħal",
  "block.minecraft.beehive": "Duqqajs",
  "block.minecraft.beetroots": "Pitravi",
  "block.minecraft.bell": "Qanpiena",
  "block.minecraft.big_dripleaf": "Werqatra Kbira",
  "block.minecraft.big_dripleaf_stem": "Zokk tal-Werqatra Kbira",
  "block.minecraft.birch_button": "Buttuna tal-Betula",
  "block.minecraft.birch_door": "Bieb tal-Betula",
  "block.minecraft.birch_fence": "Ċint tal-Betula",
  "block.minecraft.birch_fence_gate": "Grada tal-Betula",
  "block.minecraft.birch_hanging_sign": "Tabella Mdendla tal-Betula",
  "block.minecraft.birch_leaves": "Weraq tal-Betula",
  "block.minecraft.birch_log": "Zokk tal-Betula",
  "block.minecraft.birch_planks": "Twavel tal-Betula",
  "block.minecraft.birch_pressure_plate": "Pjanċa tal-Betula",
  "block.minecraft.birch_sapling": "Żgħar tal-Betula",
  "block.minecraft.birch_shelf": "Xkaffa tal-Betula",
  "block.minecraft.birch_sign": "Tabella tal-Betula",
  "block.minecraft.birch_slab": "Ċangun tal-Betula",
  "block.minecraft.birch_stairs": "Taraġ tal-Betula",
  "block.minecraft.birch_trapdoor": "Bokkaport tal-Betula",
  "block.minecraft.birch_wall_hanging_sign": "Tabella tal-Ħajt Imdendla tal-Betula",
  "block.minecraft.birch_wall_sign": "Tabella tal-Betula mal-Ħajt",
  "block.minecraft.birch_wood": "Injam tal-Betula",
  "block.minecraft.black_banner": "Strixxun Iswed",
  "block.minecraft.black_bed": "Sodda Sewda",
  "block.minecraft.black_candle": "Xemgħa sewda",
  "block.minecraft.black_candle_cake": "Kejk b'Xemgħa Sewda",
  "block.minecraft.black_carpet": "Tapit Iswed",
  "block.minecraft.black_concrete": "Konkrit Iswed",
  "block.minecraft.black_concrete_powder": "Konkrit Imtarrab Iswed",
  "block.minecraft.black_glazed_terracotta": "Terrakotta Żmaltata Sewda",
  "block.minecraft.black_shulker_box": "Kaxxa Qoxrana Sewda",
  "block.minecraft.black_stained_glass": "Ħġieġ Miżbugħ Iswed",
  "block.minecraft.black_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Sewda",
  "block.minecraft.black_terracotta": "Terrakotta Sewda",
  "block.minecraft.black_wool": "Suf Iswed",
  "block.minecraft.blackstone": "Ġebla Sewda",
  "block.minecraft.blackstone_slab": "Ċangatura tal-Ġebla Sewda",
  "block.minecraft.blackstone_stairs": "Taraġ tal-Ġebla Sewda",
  "block.minecraft.blackstone_wall": "Ħajt tal-Ġebla Sewda",
  "block.minecraft.blast_furnace": "Forn il-Funderija",
  "block.minecraft.blue_banner": "Strixxun Blu",
  "block.minecraft.blue_bed": "Sodda Blu",
  "block.minecraft.blue_candle": "Xemgħa blu",
  "block.minecraft.blue_candle_cake": "Kejk b'Xemgħa Blu",
  "block.minecraft.blue_carpet": "Tapit Blu",
  "block.minecraft.blue_concrete": "Konkrit Blu",
  "block.minecraft.blue_concrete_powder": "Konkrit Imtarrab Blu",
  "block.minecraft.blue_glazed_terracotta": "Terrakotta bi tleqqija ikħal",
  "block.minecraft.blue_ice": "Silġ Blu",
  "block.minecraft.blue_orchid": "Orkidea Blu",
  "block.minecraft.blue_shulker_box": "Kaxxa Qoxrana Blu",
  "block.minecraft.blue_stained_glass": "Ħġieġ Miżbugħ Blu",
  "block.minecraft.blue_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Blu",
  "block.minecraft.blue_terracotta": "Terrakotta Blu",
  "block.minecraft.blue_wool": "Suf Blu",
  "block.minecraft.bone_block": "Blokka Għadam",
  "block.minecraft.bookshelf": "Xkafef",
  "block.minecraft.brain_coral": "Qroll tal-Moħħ",
  "block.minecraft.brain_coral_block": "Blokka Qroll tal-Moħħ",
  "block.minecraft.brain_coral_fan": "Fann Qroll tal-Moħħ",
  "block.minecraft.brain_coral_wall_fan": "Fann Qroll tal-Moħħ mal-Ħajt",
  "block.minecraft.brewing_stand": "Birrerija",
  "block.minecraft.brick_slab": "Ċangun tal-Briks",
  "block.minecraft.brick_stairs": "Taraġ tal-Briks",
  "block.minecraft.brick_wall": "Ħajt tal-Briks",
  "block.minecraft.bricks": "Briks",
  "block.minecraft.brown_banner": "Bandiera Kannella",
  "block.minecraft.brown_bed": "Sodda Kannella",
  "block.minecraft.brown_candle": "Xemgħa kannella",
  "block.minecraft.brown_candle_cake": "Kejk b'Xemgħa Kannella",
  "block.minecraft.brown_carpet": "Tapit Kannella",
  "block.minecraft.brown_concrete": "Konkrit Kannella",
  "block.minecraft.brown_concrete_powder": "Konkrit Imtarrab Kannella",
  "block.minecraft.brown_glazed_terracotta": "Terrakotta bi tleqqija kannella",
  "block.minecraft.brown_mushroom": "Faqqiegħ Kannella",
  "block.minecraft.brown_mushroom_block": "Blokka tal-Faqqiegħ Kannella",
  "block.minecraft.brown_shulker_box": "Kaxxa Qoxrana Kannella",
  "block.minecraft.brown_stained_glass": "Ħġieġ Miżbugħ Kannella",
  "block.minecraft.brown_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Kannella",
  "block.minecraft.brown_terracotta": "Terrakotta Kannella",
  "block.minecraft.brown_wool": "Suf Kannella",
  "block.minecraft.bubble_column": "Kolonna tal-Bżieżaq",
  "block.minecraft.bubble_coral": "Qroll tal-Bżieżaq",
  "block.minecraft.bubble_coral_block": "Blokka Qroll tal-Bżieżaq",
  "block.minecraft.bubble_coral_fan": "Fann tal-Bżieżaq",
  "block.minecraft.bubble_coral_wall_fan": "Fann tal-Bżieżaq mal-Ħajt",
  "block.minecraft.budding_amethyst": "Ametista Blanzuna",
  "block.minecraft.bush": "Arbuxxell",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Fjura tal-Kaktus",
  "block.minecraft.cake": "Kejk",
  "block.minecraft.calcite": "Kalċit",
  "block.minecraft.calibrated_sculk_sensor": "Ħassies l-Iskulk Ikkalibrat",
  "block.minecraft.campfire": "Ħuġġieġa",
  "block.minecraft.candle": "Xemg ħa",
  "block.minecraft.candle_cake": "Kejk xemgħa",
  "block.minecraft.carrots": "Karrotti",
  "block.minecraft.cartography_table": "Mejda tal-Kartografija",
  "block.minecraft.carved_pumpkin": "Qargħa Ħamra Mnaqqxa",
  "block.minecraft.cauldron": "Kaldarun",
  "block.minecraft.cave_air": "Arja t'Għar",
  "block.minecraft.cave_vines": "Dwieli tal-Għerien",
  "block.minecraft.cave_vines_plant": "Pjanta tad-Dwieli tal-Għerien",
  "block.minecraft.chain": "Katina",
  "block.minecraft.chain_command_block": "Blokka tal-Kodiċi Katina",
  "block.minecraft.cherry_button": "Buttuna taċ-Ċirasa",
  "block.minecraft.cherry_door": "Bieb taċ-Ċirasa",
  "block.minecraft.cherry_fence": "Ilqugħ taċ-Ċirasa",
  "block.minecraft.cherry_fence_gate": "Xatba taċ-Ċirasa",
  "block.minecraft.cherry_hanging_sign": "Tabella Mdendla taċ-Ċirasa",
  "block.minecraft.cherry_leaves": "Weraq taċ-Ċirasa",
  "block.minecraft.cherry_log": "Zokk taċ-Ċirasa",
  "block.minecraft.cherry_planks": "Twavel taċ-Ċirasa",
  "block.minecraft.cherry_pressure_plate": "Pjanċa taċ-Ċirasa",
  "block.minecraft.cherry_sapling": "Sġajra taċ-Ċirasa",
  "block.minecraft.cherry_shelf": "Xkaffa taċ-Ċirasa",
  "block.minecraft.cherry_sign": "Tabella taċ-Ċirasa",
  "block.minecraft.cherry_slab": "Ċangun taċ-Ċirasa",
  "block.minecraft.cherry_stairs": "Taraġ taċ-Ċirasa",
  "block.minecraft.cherry_trapdoor": "Bokkaport taċ-Ċirasa",
  "block.minecraft.cherry_wall_hanging_sign": "Tabella taċ-Ċirasa Mdendla mal-Ħajt",
  "block.minecraft.cherry_wall_sign": "Tabella taċ-Ċirasa mal-Ħajt",
  "block.minecraft.cherry_wood": "Injam taċ-Ċirasa",
  "block.minecraft.chest": "Senduq",
  "block.minecraft.chipped_anvil": "Inkwina Mxaqqa",
  "block.minecraft.chiseled_bookshelf": "Xkaffa Mnaqqxa",
  "block.minecraft.chiseled_copper": "Ram Imnaqqax",
  "block.minecraft.chiseled_deepslate": "Lavanja Mnaqqxa",
  "block.minecraft.chiseled_nether_bricks": "Briks Taħħat Imnaqqax",
  "block.minecraft.chiseled_polished_blackstone": "Ġebla Sewda Illostrata bid-Disinn",
  "block.minecraft.chiseled_quartz_block": "Blokka tal-Kwarz Imnaqqxa",
  "block.minecraft.chiseled_red_sandstone": "Ġebel Aħmar tal-Franka Mnaqqax",
  "block.minecraft.chiseled_resin_bricks": "Briks tar-Reżina Mnaqqxa",
  "block.minecraft.chiseled_sandstone": "Ġebel tal-Franka Mnaqqax",
  "block.minecraft.chiseled_stone_bricks": "Briks tal-Ġebel Imnaqqax",
  "block.minecraft.chiseled_tuff": "Tufu Mnaqqax",
  "block.minecraft.chiseled_tuff_bricks": "Briks tat-Tufu Mnaqqax",
  "block.minecraft.chorus_flower": "Fjura tal-Chorus",
  "block.minecraft.chorus_plant": "Xitla tal-Chorus",
  "block.minecraft.clay": "Tafal",
  "block.minecraft.closed_eyeblossom": "Żahret il-Għajn Magħluqa",
  "block.minecraft.coal_block": "Blokka tal-Faħam",
  "block.minecraft.coal_ore": "Sigħat tal-Faħam",
  "block.minecraft.coarse_dirt": "Ħamrija Ħoxna",
  "block.minecraft.cobbled_deepslate": "Lavanja Mfarrka",
  "block.minecraft.cobbled_deepslate_slab": "Ċangun tal-Lavanja Mfarrka",
  "block.minecraft.cobbled_deepslate_stairs": "Taraġ tal-Lavanja Mfarrka",
  "block.minecraft.cobbled_deepslate_wall": "Ċint tal-Lavanja Mfarrka",
  "block.minecraft.cobblestone": "Ġebel Imfarrak",
  "block.minecraft.cobblestone_slab": "Ċangun tal-Ġebel Imfarrak",
  "block.minecraft.cobblestone_stairs": "Taraġ tal-Ġebel",
  "block.minecraft.cobblestone_wall": "Ħajt tas-Sejjieħ",
  "block.minecraft.cobweb": "Għanqbuta",
  "block.minecraft.cocoa": "Kakaw",
  "block.minecraft.command_block": "Blokka tal-Kodiċi",
  "block.minecraft.comparator": "Komparatur tar-Redstone",
  "block.minecraft.composter": "Demmiel",
  "block.minecraft.conduit": "Kondott",
  "block.minecraft.copper_bars": "Vireg tar-Ram",
  "block.minecraft.copper_block": "Blokka tar-Ram",
  "block.minecraft.copper_bulb": "Bozza tar-Ram",
  "block.minecraft.copper_chain": "Katina tar-Ram",
  "block.minecraft.copper_chest": "Senduq tar-Ram",
  "block.minecraft.copper_door": "Bieb tar-Ram",
  "block.minecraft.copper_golem_statue": "Statwa tal-Ġgantin tar-Ram",
  "block.minecraft.copper_grate": "Gradilja tar-Ram",
  "block.minecraft.copper_lantern": "Fanal tar-Ram",
  "block.minecraft.copper_ore": "Minerali tar-Ram",
  "block.minecraft.copper_torch": "Torċa tar-Ram",
  "block.minecraft.copper_trapdoor": "Bokkaport tar-Ram",
  "block.minecraft.copper_wall_torch": "Torċa tar-Ram mal-Ħajt",
  "block.minecraft.cornflower": "Ċentawrija",
  "block.minecraft.cracked_deepslate_bricks": "Briks tal-Lavanja Mxaqqin",
  "block.minecraft.cracked_deepslate_tiles": "Madum tal-Lavanja Mxaqqin",
  "block.minecraft.cracked_nether_bricks": "Briks tat-Taħta Imxaqqin",
  "block.minecraft.cracked_polished_blackstone_bricks": "Briksiet tal-Ġebla Sewda Illostrati bil-Konsenturi",
  "block.minecraft.cracked_stone_bricks": "Briks tal-Ġebel Imxaqqaq",
  "block.minecraft.crafter": "Artiġjan",
  "block.minecraft.crafting_table": "Mejda tas-Snajja",
  "block.minecraft.creaking_heart": "Qalb Żaqżieqa",
  "block.minecraft.creeper_head": "Ras ta' Creeper",
  "block.minecraft.creeper_wall_head": "Ras tal-Ħajt tal-Kaxkar",
  "block.minecraft.crimson_button": "Buttuna Krimżi",
  "block.minecraft.crimson_door": "Bieb Krimżi",
  "block.minecraft.crimson_fence": "Ċint Krimżi",
  "block.minecraft.crimson_fence_gate": "Grada Krimżi",
  "block.minecraft.crimson_fungus": "Fungi Krimżi",
  "block.minecraft.crimson_hanging_sign": "Tabella Mdendla Krimżi",
  "block.minecraft.crimson_hyphae": "Ħajfi Krimżi",
  "block.minecraft.crimson_nylium": "Njlium Krimżi",
  "block.minecraft.crimson_planks": "Planki Krimżi",
  "block.minecraft.crimson_pressure_plate": "Pjanċa tal-Pressjoni Krimżi",
  "block.minecraft.crimson_roots": "Għeruq Krimżi",
  "block.minecraft.crimson_shelf": "Xkaffa Krimżi",
  "block.minecraft.crimson_sign": "Tabella Krimżi",
  "block.minecraft.crimson_slab": "Krimżi Blata",
  "block.minecraft.crimson_stairs": "Taraġ Krimżi",
  "block.minecraft.crimson_stem": "Zokk Krimżi",
  "block.minecraft.crimson_trapdoor": "Bieba Krimżi",
  "block.minecraft.crimson_wall_hanging_sign": "Tabella tal-Ħajt Tiddendel Krimżi",
  "block.minecraft.crimson_wall_sign": "Tabella Krimżi mal-Ħajt",
  "block.minecraft.crying_obsidian": "Obsidjana tal-Biki",
  "block.minecraft.cut_copper": "Ram maqtugħ",
  "block.minecraft.cut_copper_slab": "Slab tar-ram maqtugħ",
  "block.minecraft.cut_copper_stairs": "Taraġ tar-Ram Maqtugħ",
  "block.minecraft.cut_red_sandstone": "Franka Ħamra Maqtugħa",
  "block.minecraft.cut_red_sandstone_slab": "Ċangun tal-Franka Ħamra Maqtugħ",
  "block.minecraft.cut_sandstone": "Franka Maqtugħa",
  "block.minecraft.cut_sandstone_slab": "Ċangun tal-Franka Maqtugħ",
  "block.minecraft.cyan_banner": "Strixxun Iżraq",
  "block.minecraft.cyan_bed": "Sodda Żerqa",
  "block.minecraft.cyan_candle": "Xemgħa Żerqa",
  "block.minecraft.cyan_candle_cake": "Kejk b'Xemgħa Żerqa",
  "block.minecraft.cyan_carpet": "Tapit Blu fl-Aħdar",
  "block.minecraft.cyan_concrete": "Konkrit Iżraq",
  "block.minecraft.cyan_concrete_powder": "Konkrit Imtarrab Iżraq",
  "block.minecraft.cyan_glazed_terracotta": "Terrakotta bi tleqqija cyan",
  "block.minecraft.cyan_shulker_box": "Kaxxa Qoxrana Iżraq",
  "block.minecraft.cyan_stained_glass": "Ħġieġ Miżbugħ Blu fl-Aħdar",
  "block.minecraft.cyan_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Blu fl-Aħdar",
  "block.minecraft.cyan_terracotta": "Terrakotta Żerqa",
  "block.minecraft.cyan_wool": "Suf Blu fl-Aħdar",
  "block.minecraft.damaged_anvil": "Inkwina Mgerbġa",
  "block.minecraft.dandelion": "Lelluxa",
  "block.minecraft.dark_oak_button": "Buttuna tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_door": "Bieb tal-Ballut Skur",
  "block.minecraft.dark_oak_fence": "Ċint tal-Ballut Skur",
  "block.minecraft.dark_oak_fence_gate": "Grada tal-Ballut Skur",
  "block.minecraft.dark_oak_hanging_sign": "Tabella Mdendla tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_leaves": "Wearaq tal-Ballut Skur",
  "block.minecraft.dark_oak_log": "Zokk tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_planks": "Twavel tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_pressure_plate": "Pjanċa tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_sapling": "Żġħar tal-Ballut Skur",
  "block.minecraft.dark_oak_shelf": "Xkaffa tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_sign": "Tabella tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_slab": "Ċangun tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_stairs": "Taraġ tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_trapdoor": "Bokkaport tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tabella tal-Ħajt Imdendla tal-Ballut Dagħmi",
  "block.minecraft.dark_oak_wall_sign": "Tabella tal-Ballut Dagħmi mal-Ħajt",
  "block.minecraft.dark_oak_wood": "Injam tal-Ballut Skur",
  "block.minecraft.dark_prismarine": "Prismarine Skur",
  "block.minecraft.dark_prismarine_slab": "Ċangun tal-Priżmarin Dagħmi",
  "block.minecraft.dark_prismarine_stairs": "Taraġ tal-Priżmarin Dagħmi",
  "block.minecraft.daylight_detector": "Ħassies il-Jum",
  "block.minecraft.dead_brain_coral": "Qroll tal-Moħħ Mejjet",
  "block.minecraft.dead_brain_coral_block": "Blokka Qroll tal-Moħħ Mejjet",
  "block.minecraft.dead_brain_coral_fan": "Fann tal-Moħħ Mejjet",
  "block.minecraft.dead_brain_coral_wall_fan": "Fann tal-Moħħ Mejjet mal-Ħajt",
  "block.minecraft.dead_bubble_coral": "Qroll tal-Bżieżaq Mejjet",
  "block.minecraft.dead_bubble_coral_block": "Blokka tal-Qroll tal-Bżieżaq Mejjet",
  "block.minecraft.dead_bubble_coral_fan": "Fann tal-Bżieżaq Mejjet",
  "block.minecraft.dead_bubble_coral_wall_fan": "Fann tal-Bżieżaq Mejjet mal-Ħajt",
  "block.minecraft.dead_bush": "Xitla Niexfa",
  "block.minecraft.dead_fire_coral": "Qroll tan-Nar Mejjet",
  "block.minecraft.dead_fire_coral_block": "Blokka tal-Qroll tan-Nar Mejjet",
  "block.minecraft.dead_fire_coral_fan": "Fann tan-Nar Mejjet",
  "block.minecraft.dead_fire_coral_wall_fan": "Fann tan-Nar Mejjet mal-Ħajt",
  "block.minecraft.dead_horn_coral": "Qroll tal-Qrun Mejjet",
  "block.minecraft.dead_horn_coral_block": "Blokka tal-Qroll tal-Qrun Mejjet",
  "block.minecraft.dead_horn_coral_fan": "Fann tal-Qrun Mejjet",
  "block.minecraft.dead_horn_coral_wall_fan": "Fann tal-Qrun Mejjet mal-Ħajt",
  "block.minecraft.dead_tube_coral": "Qroll tat-Tubu Mejjet",
  "block.minecraft.dead_tube_coral_block": "Blokka tal-Qroll tat-Tubu Mejjet",
  "block.minecraft.dead_tube_coral_fan": "Fann tat-Tubu Mejjet",
  "block.minecraft.dead_tube_coral_wall_fan": "Fann tat-Tubu Mejjet mal-Ħajt",
  "block.minecraft.decorated_pot": "Vażun Imżejjen",
  "block.minecraft.deepslate": "Lavanja",
  "block.minecraft.deepslate_brick_slab": "Ċangun tal-Briks tal-Lavanja",
  "block.minecraft.deepslate_brick_stairs": "Taraġ tal-Briks tal-Lavanja",
  "block.minecraft.deepslate_brick_wall": "Ċint tal-Briks tal-Lavanja",
  "block.minecraft.deepslate_bricks": "Briks tal-Lavanja",
  "block.minecraft.deepslate_coal_ore": "Minerali tal-Faħam tal-Lavanja",
  "block.minecraft.deepslate_copper_ore": "Minerali tar-Ram tal-Lavanja",
  "block.minecraft.deepslate_diamond_ore": "Minerali tad-Djamant tal-Lavanja",
  "block.minecraft.deepslate_emerald_ore": "Minerali tal-Iżmerald tal-Lavanja",
  "block.minecraft.deepslate_gold_ore": "Minerali tad-Deheb tal-Lavanja",
  "block.minecraft.deepslate_iron_ore": "Minerali tal-Ħadid tal-Lavanja",
  "block.minecraft.deepslate_lapis_ore": "Minerali tal-Lażurit tal-Lavanja",
  "block.minecraft.deepslate_redstone_ore": "Minerali tal-Ġeblaħamra tal-Lavanja",
  "block.minecraft.deepslate_tile_slab": "Ċangun tal-Madum tal-Lavanja",
  "block.minecraft.deepslate_tile_stairs": "Taraġ tal-Madum tal-Lavanja",
  "block.minecraft.deepslate_tile_wall": "Ċint tal-Madum tal-Lavanja",
  "block.minecraft.deepslate_tiles": "Madum tal-Lavanja",
  "block.minecraft.detector_rail": "Linji Didekters",
  "block.minecraft.diamond_block": "Blokka tad-Djamant",
  "block.minecraft.diamond_ore": "Sigħat tad-Djamant",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Ċangun tad-Dijorit",
  "block.minecraft.diorite_stairs": "Taraġ tad-Dijorit",
  "block.minecraft.diorite_wall": "Ċint tad-Dijorit",
  "block.minecraft.dirt": "Ħamrija",
  "block.minecraft.dirt_path": "Mogħdija tal-Ħmieġ",
  "block.minecraft.dispenser": "Dispensur",
  "block.minecraft.dragon_egg": "Bajda ta' Dragun",
  "block.minecraft.dragon_head": "Ras ta' Dragun",
  "block.minecraft.dragon_wall_head": "Ras id-Dragun mal-Ħajt",
  "block.minecraft.dried_ghast": "Waħħax Imnixxef",
  "block.minecraft.dried_kelp_block": "Blokka tal-Alka Mnixxfa",
  "block.minecraft.dripstone_block": "Blokka tal-ġebel tad-dripp",
  "block.minecraft.dropper": "Qattara",
  "block.minecraft.emerald_block": "Blokka tal-Iżmerald",
  "block.minecraft.emerald_ore": "Sigħat tal-Iżmerald",
  "block.minecraft.enchanting_table": "Mejda tat-Tisħir",
  "block.minecraft.end_gateway": "Bieb Temmiem",
  "block.minecraft.end_portal": "Portal tal-Ender",
  "block.minecraft.end_portal_frame": "Qafas Temmiem",
  "block.minecraft.end_rod": "Virga tal-Ender",
  "block.minecraft.end_stone": "Ġebel tal-Ender",
  "block.minecraft.end_stone_brick_slab": "Ċangun tal-Briks tal-Ġebel Temmiemi",
  "block.minecraft.end_stone_brick_stairs": "Taraġ tal-Briks tal-Ġebel Temmiemi",
  "block.minecraft.end_stone_brick_wall": "Ċint tal-Briks tal-Ġebel Temmiemi",
  "block.minecraft.end_stone_bricks": "Briks tal-Ġebel tal-Ender",
  "block.minecraft.ender_chest": "Senduq tal-Ender",
  "block.minecraft.exposed_chiseled_copper": "Ram Imnaqqax Espost",
  "block.minecraft.exposed_copper": "Ram Espost",
  "block.minecraft.exposed_copper_bars": "Vireg tar-Ram Espost",
  "block.minecraft.exposed_copper_bulb": "Bozza tar-Ram Esposta",
  "block.minecraft.exposed_copper_chain": "Katina tar-Ram Esposta",
  "block.minecraft.exposed_copper_chest": "Senduq tar-Ram Espost",
  "block.minecraft.exposed_copper_door": "Bieb tar-Ram Espost",
  "block.minecraft.exposed_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Espost",
  "block.minecraft.exposed_copper_grate": "Gradilja tar-Ram Esposta",
  "block.minecraft.exposed_copper_lantern": "Fanal tar-Ram Espost",
  "block.minecraft.exposed_copper_trapdoor": "Bokkaport tar-Ram Espost",
  "block.minecraft.exposed_cut_copper": "Ram Maqtugħ Espost",
  "block.minecraft.exposed_cut_copper_slab": "Ċangun tar-Ram Maqtugħ Espost",
  "block.minecraft.exposed_cut_copper_stairs": "Taraġ tar-Ramm Maqtugħ Espost",
  "block.minecraft.exposed_lightning_rod": "Virga tas-Sajjetti Esposta",
  "block.minecraft.farmland": "Art tar-Raba",
  "block.minecraft.fern": "Xitla",
  "block.minecraft.fire": "Nar",
  "block.minecraft.fire_coral": "Qroll tan-Nar",
  "block.minecraft.fire_coral_block": "Blokka tal-Qroll tan-Nar",
  "block.minecraft.fire_coral_fan": "Fann tal-Qroll tan-Nar",
  "block.minecraft.fire_coral_wall_fan": "Fann tal-Ħajt tal-Qroll tan-Nar",
  "block.minecraft.firefly_bush": "Arbuxxell tal-Musbieħ il-Lejl",
  "block.minecraft.fletching_table": "Mejda tat-Taqwis",
  "block.minecraft.flower_pot": "Qasrija",
  "block.minecraft.flowering_azalea": "Ażalea Mwarrda",
  "block.minecraft.flowering_azalea_leaves": "Weraq tal-Ażalea Mwarrda",
  "block.minecraft.frogspawn": "Bajd tal-Marżepp",
  "block.minecraft.frosted_ice": "Silġ Iffriżat",
  "block.minecraft.furnace": "Forn",
  "block.minecraft.gilded_blackstone": "Ġebla Sewda Indurata",
  "block.minecraft.glass": "Ħġieġ",
  "block.minecraft.glass_pane": "Ħġieġa Ċatta",
  "block.minecraft.glow_lichen": "Likena Dawwala",
  "block.minecraft.glowstone": "Ġebel Jixgħel",
  "block.minecraft.gold_block": "Blokka tad-Deheb",
  "block.minecraft.gold_ore": "Sigħat tad-Deheb",
  "block.minecraft.golden_dandelion": "Lelluxa Dehbija",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Ċangun tal-Granit",
  "block.minecraft.granite_stairs": "Taraġ tal-Granit",
  "block.minecraft.granite_wall": "Ċint tal-Granit",
  "block.minecraft.grass": "Ħaxix",
  "block.minecraft.grass_block": "Blokka tal-Ħaxix",
  "block.minecraft.gravel": "Żrar",
  "block.minecraft.gray_banner": "Strixxun Griż",
  "block.minecraft.gray_bed": "Sodda Griża",
  "block.minecraft.gray_candle": "Xemgħa griża",
  "block.minecraft.gray_candle_cake": "Kejk b'Xemgħa Griża",
  "block.minecraft.gray_carpet": "Tapit Griż",
  "block.minecraft.gray_concrete": "Konkrit Griż",
  "block.minecraft.gray_concrete_powder": "Konkrit Imtarrab Griż",
  "block.minecraft.gray_glazed_terracotta": "Terrakotta Żmaltata Griża",
  "block.minecraft.gray_shulker_box": "Kaxxa Qoxrana Griża",
  "block.minecraft.gray_stained_glass": "Ħġieġ Miżbugħ Griż",
  "block.minecraft.gray_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Griża",
  "block.minecraft.gray_terracotta": "Terrakotta griż",
  "block.minecraft.gray_wool": "Suf Griż",
  "block.minecraft.green_banner": "Strixxun Aħdar",
  "block.minecraft.green_bed": "Sodda Ħadra",
  "block.minecraft.green_candle": "Xemgħa ħadra",
  "block.minecraft.green_candle_cake": "Kejk b'Xemgħa Ħadra",
  "block.minecraft.green_carpet": "Tapit Aħdar",
  "block.minecraft.green_concrete": "Konkrit Aħdar",
  "block.minecraft.green_concrete_powder": "Konkrit Imtarrab Aħdar",
  "block.minecraft.green_glazed_terracotta": "Terrakotta Żmaltata Ħadra",
  "block.minecraft.green_shulker_box": "Kaxxa Qoxrana Kannella",
  "block.minecraft.green_stained_glass": "Ħġieġ Miżbugħ Aħdar",
  "block.minecraft.green_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Ħadra",
  "block.minecraft.green_terracotta": "Terrakotta Ħadra",
  "block.minecraft.green_wool": "Suf Aħdar",
  "block.minecraft.grindstone": "Mola",
  "block.minecraft.hanging_roots": "Għeruq Imdendlin",
  "block.minecraft.hay_block": "Tiben",
  "block.minecraft.heavy_core": "Qalba Mtaqqla",
  "block.minecraft.heavy_weighted_pressure_plate": "Pjanċa Ppiżata Tqila",
  "block.minecraft.honey_block": "Blokka Għasel",
  "block.minecraft.honeycomb_block": "Blokk Xehda",
  "block.minecraft.hopper": "Lembut",
  "block.minecraft.horn_coral": "Qroll tal-Qrun",
  "block.minecraft.horn_coral_block": "Blokka tal-Qroll tal-Qrun",
  "block.minecraft.horn_coral_fan": "Fann tal-Qrun",
  "block.minecraft.horn_coral_wall_fan": "Fann tal-Ħajt tal-Qrun",
  "block.minecraft.ice": "Silġ",
  "block.minecraft.infested_chiseled_stone_bricks": "Briks tal-Ġebel Imnaqqxa Kamlin",
  "block.minecraft.infested_cobblestone": "Ċagħaq Kamli",
  "block.minecraft.infested_cracked_stone_bricks": "Briks tal-Ġebel Imxaqqaq Kamlin",
  "block.minecraft.infested_deepslate": "Lavanja Kamlija",
  "block.minecraft.infested_mossy_stone_bricks": "Briks tal-Ġebel Imħażżin Kamlin",
  "block.minecraft.infested_stone": "Ġebel Kamli",
  "block.minecraft.infested_stone_bricks": "Briks tal-Ġebel Kamlin",
  "block.minecraft.iron_bars": "Vireg tal-Ħadid",
  "block.minecraft.iron_block": "Blokka tal-Ħadid",
  "block.minecraft.iron_chain": "Katina tal-Ħadid",
  "block.minecraft.iron_door": "Bieb tal-Ħadid",
  "block.minecraft.iron_ore": "Sigħat tal-Ħadid",
  "block.minecraft.iron_trapdoor": "Bokkaport tal-Ħadid",
  "block.minecraft.jack_o_lantern": "Qargħa Ħamra Tixgħel",
  "block.minecraft.jigsaw": "Blokka Biċċiera",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Buttuna tal-Ġungla",
  "block.minecraft.jungle_door": "Bieb tal-Injam tal-Ġungla",
  "block.minecraft.jungle_fence": "Ċint tal-Injam tal-Ġungla",
  "block.minecraft.jungle_fence_gate": "Grada tal-Injam tal-Ġungla",
  "block.minecraft.jungle_hanging_sign": "Tabella Mdendla tal-Ġungla",
  "block.minecraft.jungle_leaves": "Weraq tal-Ġungla",
  "block.minecraft.jungle_log": "Zokk tal-Ġungla",
  "block.minecraft.jungle_planks": "Twavel tal-Ġungla",
  "block.minecraft.jungle_pressure_plate": "Pjanċa tal-Ġungla",
  "block.minecraft.jungle_sapling": "Żgħar tal-Ġungla",
  "block.minecraft.jungle_shelf": "Xkaffa tal-Ġungla",
  "block.minecraft.jungle_sign": "Tabella tal-Ġungla",
  "block.minecraft.jungle_slab": "Ċangun tal-Ġungla",
  "block.minecraft.jungle_stairs": "Taraġ tal-Ġungla",
  "block.minecraft.jungle_trapdoor": "Bokkaport tal-Ġungla",
  "block.minecraft.jungle_wall_hanging_sign": "Tabella tal-Ħajt Imdendla tal-Ġungla",
  "block.minecraft.jungle_wall_sign": "Tabella tal-Ħajt tal-Ġungla",
  "block.minecraft.jungle_wood": "Injam tal-Ġungla",
  "block.minecraft.kelp": "Alka",
  "block.minecraft.kelp_plant": "Pjanta tal-Alka",
  "block.minecraft.ladder": "Sellum",
  "block.minecraft.lantern": "Fanal",
  "block.minecraft.lapis_block": "Blokk ta' Lapis Lazuli",
  "block.minecraft.lapis_ore": "Sigħat tal-Lapis Lazuli",
  "block.minecraft.large_amethyst_bud": "Blanzun Kbir tal-Ametista",
  "block.minecraft.large_fern": "Xitla Kbira",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kaldarun tal-Lava",
  "block.minecraft.leaf_litter": "Weraq Niexef",
  "block.minecraft.lectern": "Maqar",
  "block.minecraft.lever": "Swiċċ",
  "block.minecraft.light": "Dawl",
  "block.minecraft.light_blue_banner": "Strixxun Ikħal",
  "block.minecraft.light_blue_bed": "Sodda Kaħla",
  "block.minecraft.light_blue_candle": "Xemgħa Kaħla",
  "block.minecraft.light_blue_candle_cake": "Kejk b'Xemgħa Kaħla",
  "block.minecraft.light_blue_carpet": "Tapit Blu Ċar",
  "block.minecraft.light_blue_concrete": "Konkrit Ikħal",
  "block.minecraft.light_blue_concrete_powder": "Konkrit Imtarrab Ikħal",
  "block.minecraft.light_blue_glazed_terracotta": "Terrakotta bit-tleqqija ikħal ċar",
  "block.minecraft.light_blue_shulker_box": "Kaxxa Qoxrana Kaħla",
  "block.minecraft.light_blue_stained_glass": "Ħġieġ Miżbugħ Blu Ċar",
  "block.minecraft.light_blue_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Blu Ċar",
  "block.minecraft.light_blue_terracotta": "Terrakotta Kaħla",
  "block.minecraft.light_blue_wool": "Suf Blu Ċar",
  "block.minecraft.light_gray_banner": "Strixxun Ixheb",
  "block.minecraft.light_gray_bed": "Sodda Xehba",
  "block.minecraft.light_gray_candle": "Xemgħa Xehba",
  "block.minecraft.light_gray_candle_cake": "Kejk b'Xemgħa Xehba",
  "block.minecraft.light_gray_carpet": "Tapit Griż Ċar",
  "block.minecraft.light_gray_concrete": "Konkrit Ixheb",
  "block.minecraft.light_gray_concrete_powder": "Konkrit Imtarrab Ixheb",
  "block.minecraft.light_gray_glazed_terracotta": "Terrakotta Żmaltata Xehba",
  "block.minecraft.light_gray_shulker_box": "Kaxxa Qoxrana Xehba",
  "block.minecraft.light_gray_stained_glass": "Ħġieġ Miżbugħ Griż Ċar",
  "block.minecraft.light_gray_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Griża Ċara",
  "block.minecraft.light_gray_terracotta": "Terrakotta Xehba",
  "block.minecraft.light_gray_wool": "Suf Griż Ċar",
  "block.minecraft.light_weighted_pressure_plate": "Pjanċa Ppiżata Ħafifa",
  "block.minecraft.lightning_rod": "Virga tas-sajjetti",
  "block.minecraft.lilac": "Lela'",
  "block.minecraft.lily_of_the_valley": "Ġilju",
  "block.minecraft.lily_pad": "Pjanta tal-Ilma",
  "block.minecraft.lime_banner": "Strixxun Limett",
  "block.minecraft.lime_bed": "Sodda Limetta",
  "block.minecraft.lime_candle": "Xemgħa tal-ġir",
  "block.minecraft.lime_candle_cake": "Kejk b'Xemgħa Limetta",
  "block.minecraft.lime_carpet": "Tapit Aħdar Ċar",
  "block.minecraft.lime_concrete": "Konkrit Limett",
  "block.minecraft.lime_concrete_powder": "Konkrit Imtarrab Limett",
  "block.minecraft.lime_glazed_terracotta": "Terrakotta bit-tleqqija aħdar ċar",
  "block.minecraft.lime_shulker_box": "Kaxxa Qoxrana Limetta",
  "block.minecraft.lime_stained_glass": "Ħġieġ Miżbugħ Aħdar Ċar",
  "block.minecraft.lime_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Ħadra Ċara",
  "block.minecraft.lime_terracotta": "Terrakotta Limetta",
  "block.minecraft.lime_wool": "Suf Aħdar Ċar",
  "block.minecraft.lodestone": "Ġebla tad-Direzzjoni",
  "block.minecraft.loom": "Newl",
  "block.minecraft.magenta_banner": "Strixxun Maġenta",
  "block.minecraft.magenta_bed": "Sodda Maġenta",
  "block.minecraft.magenta_candle": "Xemgħa tal-Magenta",
  "block.minecraft.magenta_candle_cake": "Kejk b'Xemgħa Maġenta",
  "block.minecraft.magenta_carpet": "Tapit Roża Skur",
  "block.minecraft.magenta_concrete": "Konkrit Maġenta",
  "block.minecraft.magenta_concrete_powder": "Konkrit Imtarrab Maġenta",
  "block.minecraft.magenta_glazed_terracotta": "Terrakotta Żmaltata Maġenta",
  "block.minecraft.magenta_shulker_box": "Kaxxa Qoxrana Maġenta",
  "block.minecraft.magenta_stained_glass": "Ħġieġ Miżbugħ Vjola Ċar",
  "block.minecraft.magenta_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Vjola Ċar",
  "block.minecraft.magenta_terracotta": "Terrakotta Maġenta",
  "block.minecraft.magenta_wool": "Suf Vjola Ċar",
  "block.minecraft.magma_block": "Blokka tal-Magma",
  "block.minecraft.mangrove_button": "Buttuna tal-Mangrovja",
  "block.minecraft.mangrove_door": "Bieb tal-Mangrovja",
  "block.minecraft.mangrove_fence": "Ilqugħ tal-Mangrovja",
  "block.minecraft.mangrove_fence_gate": "Xatba tal-Mangrovja",
  "block.minecraft.mangrove_hanging_sign": "Tabella Mdendla tal-Mangrovja",
  "block.minecraft.mangrove_leaves": "Weraq tal-Mangrovja",
  "block.minecraft.mangrove_log": "Zokk tal-Mangrovja",
  "block.minecraft.mangrove_planks": "Twavel tal-Mangrovja",
  "block.minecraft.mangrove_pressure_plate": "Pjanċa tal-Mangrovja",
  "block.minecraft.mangrove_propagule": "Ferħa tal-Mangrovja",
  "block.minecraft.mangrove_roots": "Għeruq tal-Mangrovja",
  "block.minecraft.mangrove_shelf": "Xkaffa tal-Mangrovja",
  "block.minecraft.mangrove_sign": "Tabella tal-Mangrovja",
  "block.minecraft.mangrove_slab": "Ċangun tal-Mangrovja",
  "block.minecraft.mangrove_stairs": "Taraġ tal-Mangrovja",
  "block.minecraft.mangrove_trapdoor": "Bokkaport tal-Mangrovja",
  "block.minecraft.mangrove_wall_hanging_sign": "Tabella Mdendla tal-Ħajt tal-Mangrovja",
  "block.minecraft.mangrove_wall_sign": "Tabella tal-Mangrovja tal-Ħajt",
  "block.minecraft.mangrove_wood": "Injam tal-Mangrovja",
  "block.minecraft.medium_amethyst_bud": "Bud Amethyst Medju",
  "block.minecraft.melon": "Dulliegħa",
  "block.minecraft.melon_stem": "Zokk tal-Dulliegħ",
  "block.minecraft.moss_block": "Blokka tal-Ħażiż",
  "block.minecraft.moss_carpet": "Tapit tal-Ħażiż",
  "block.minecraft.mossy_cobblestone": "Ċagħaq Imħażżeż",
  "block.minecraft.mossy_cobblestone_slab": "Ċangun taċ-Ċagħaq Imħażżeż",
  "block.minecraft.mossy_cobblestone_stairs": "Taraġ taċ-Ċagħaq Imħażżeż",
  "block.minecraft.mossy_cobblestone_wall": "Ħajt tas-Sejjieħ bil-Moffa",
  "block.minecraft.mossy_stone_brick_slab": "Ċangun tal-Briks tal-Ġebel Imħażżeż",
  "block.minecraft.mossy_stone_brick_stairs": "Taraġ tal-Briks tal-Ġebel Imħażżeż",
  "block.minecraft.mossy_stone_brick_wall": "Ċint tal-Briks tal-Ġebel Imħażżeż",
  "block.minecraft.mossy_stone_bricks": "Briks tal-Ġebel bil-Moffa",
  "block.minecraft.moving_piston": "Pistun Miexi",
  "block.minecraft.mud": "Tajn",
  "block.minecraft.mud_brick_slab": "Ċangun tal-Briks tat-Tajn",
  "block.minecraft.mud_brick_stairs": "Taraġ tal-Briks tat-Tajn",
  "block.minecraft.mud_brick_wall": "Ħajt tal-Briks tat-Tajn",
  "block.minecraft.mud_bricks": "Briks tat-Tajn",
  "block.minecraft.muddy_mangrove_roots": "Għeruq tal-Mangrovja Imtajna",
  "block.minecraft.mushroom_stem": "Zokk tal-Faqqiegħ",
  "block.minecraft.mycelium": "Moffa",
  "block.minecraft.nether_brick_fence": "Ċint tan-Nether",
  "block.minecraft.nether_brick_slab": "Ċangun tal-Briks tan-Nether",
  "block.minecraft.nether_brick_stairs": "Taraġ tan-Nether",
  "block.minecraft.nether_brick_wall": "Ċint tal-Briks Taħħat",
  "block.minecraft.nether_bricks": "Briks Taħħat",
  "block.minecraft.nether_gold_ore": "Ore tad-Deheb Nether",
  "block.minecraft.nether_portal": "Ġejjieb Taħħat",
  "block.minecraft.nether_quartz_ore": "Sigħat tal-Kwartz tan-Nether",
  "block.minecraft.nether_sprouts": "Nebbieta tan-Nether",
  "block.minecraft.nether_wart": "Faqqiegħ tan-Nether",
  "block.minecraft.nether_wart_block": "Blokka tal-Faqqiegħ Taħħat",
  "block.minecraft.netherite_block": "Blokk ta 'Netherajt",
  "block.minecraft.netherrack": "Ġebel tan-Nether",
  "block.minecraft.note_block": "Blokka tal-Mużika",
  "block.minecraft.oak_button": "Buttuna tal-Ballut",
  "block.minecraft.oak_door": "Bieb tal-Ballut",
  "block.minecraft.oak_fence": "Ċint tal-Ballut",
  "block.minecraft.oak_fence_gate": "Grada tal-Ballut",
  "block.minecraft.oak_hanging_sign": "Tabella Mdendla tal-Ballut",
  "block.minecraft.oak_leaves": "Weraq tal-Ballut",
  "block.minecraft.oak_log": "Zokk tal-Ballut",
  "block.minecraft.oak_planks": "Twavel tal-Ballut",
  "block.minecraft.oak_pressure_plate": "Pjanċa tal-Ballut",
  "block.minecraft.oak_sapling": "Żgħar tal-Ballut",
  "block.minecraft.oak_shelf": "Xkaffa tal-Ballut",
  "block.minecraft.oak_sign": "Tabella tal-Ballut",
  "block.minecraft.oak_slab": "Ċangun tal-Ballut",
  "block.minecraft.oak_stairs": "Taraġ tal-Ballut",
  "block.minecraft.oak_trapdoor": "Bokkaport tal-Ballut",
  "block.minecraft.oak_wall_hanging_sign": "Tabella Mdendla tal-Ħajt tal-Ballut",
  "block.minecraft.oak_wall_sign": "Tabella tal-Ballut mal-Ħajt",
  "block.minecraft.oak_wood": "Injam tal-Ballut",
  "block.minecraft.observer": "Ħarries",
  "block.minecraft.obsidian": "Ossidnu",
  "block.minecraft.ochre_froglight": "Żradawl Safrani",
  "block.minecraft.ominous_banner": "Strixxun Heddiedija",
  "block.minecraft.open_eyeblossom": "Żahret il-Għajn Miftuħa",
  "block.minecraft.orange_banner": "Strixxun Oranġjo",
  "block.minecraft.orange_bed": "Sodda Orangjo",
  "block.minecraft.orange_candle": "Xemgħa oranġjo",
  "block.minecraft.orange_candle_cake": "Kejk b'Xemgħa Oranġjo",
  "block.minecraft.orange_carpet": "Tapit Oranġjo",
  "block.minecraft.orange_concrete": "Konkrit Oranġjo",
  "block.minecraft.orange_concrete_powder": "Konkrit Imtarrab Oranġjo",
  "block.minecraft.orange_glazed_terracotta": "Terrakotta Żmaltata Oranġjo",
  "block.minecraft.orange_shulker_box": "Kaxxa Qoxrana Oranġjo",
  "block.minecraft.orange_stained_glass": "Ħġieġ Miżbugħ Oranġjo",
  "block.minecraft.orange_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Oranġjo Ċar",
  "block.minecraft.orange_terracotta": "Terrakotta Oranġjo",
  "block.minecraft.orange_tulip": "Tulip Oranġjo",
  "block.minecraft.orange_wool": "Suf Oranġjo",
  "block.minecraft.oxeye_daisy": "Narċisa",
  "block.minecraft.oxidized_chiseled_copper": "Ram Imnaqqax Imsaddad",
  "block.minecraft.oxidized_copper": "Ram Imsaddad",
  "block.minecraft.oxidized_copper_bars": "Vireg tar-Ram Imsaddin",
  "block.minecraft.oxidized_copper_bulb": "Bozza tar-Ram Imsadda",
  "block.minecraft.oxidized_copper_chain": "Katina tar-Ram Imsadda",
  "block.minecraft.oxidized_copper_chest": "Senduq tar-Ram Imsaddad",
  "block.minecraft.oxidized_copper_door": "Bieb tar-Ram Imsadda",
  "block.minecraft.oxidized_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Imsadda",
  "block.minecraft.oxidized_copper_grate": "Gradilja tar-Ram Imsadda",
  "block.minecraft.oxidized_copper_lantern": "Fanal tar-Ram Ossidizzat",
  "block.minecraft.oxidized_copper_trapdoor": "Bokkaport tar-Ram Ossidizzat",
  "block.minecraft.oxidized_cut_copper": "Ram Maqtugħ Ossidizzat",
  "block.minecraft.oxidized_cut_copper_slab": "Ċangun tar-Ram Maqtugħ Ossidizzat",
  "block.minecraft.oxidized_cut_copper_stairs": "Taraġ tar-Ramm Maqtugħ Ossidizzat",
  "block.minecraft.oxidized_lightning_rod": "Virga tas-Sajjetti Ossidizzata",
  "block.minecraft.packed_ice": "Silġ Solidu",
  "block.minecraft.packed_mud": "Tajn Maqgħud",
  "block.minecraft.pale_hanging_moss": "Ħażiż Bajdan Dendiel",
  "block.minecraft.pale_moss_block": "Blokka tal-Ħażiż Bajdan",
  "block.minecraft.pale_moss_carpet": "Tapit tal-Ħażiż Bajdan",
  "block.minecraft.pale_oak_button": "Buttuna tal-Ballut Bajdan",
  "block.minecraft.pale_oak_door": "Bieb tal-Ballut Bajdan",
  "block.minecraft.pale_oak_fence": "Ilqugħ tal-Ballut Bajdan",
  "block.minecraft.pale_oak_fence_gate": "Xatba tal-Ballut Bajdan",
  "block.minecraft.pale_oak_hanging_sign": "Tabella Mdendla tal-Ballut Bajdan",
  "block.minecraft.pale_oak_leaves": "Weraq tal-Ballut Bajdan",
  "block.minecraft.pale_oak_log": "Zokk tal-Ballut Bajdan",
  "block.minecraft.pale_oak_planks": "Twavel tal-Ballut Bajdan",
  "block.minecraft.pale_oak_pressure_plate": "Pjanċa tal-Ballut Bajdan",
  "block.minecraft.pale_oak_sapling": "Sġajra tal-Ballut Bajdan",
  "block.minecraft.pale_oak_shelf": "Xkaffa tal-Ballut Bajdan",
  "block.minecraft.pale_oak_sign": "Tabella tal-Ballut Bajdan",
  "block.minecraft.pale_oak_slab": "Ċangun tal-Ballut Bajdan",
  "block.minecraft.pale_oak_stairs": "Taraġ tal-Ballut Bajdan",
  "block.minecraft.pale_oak_trapdoor": "Blokkaport tal-Ballut Bajdan",
  "block.minecraft.pale_oak_wall_hanging_sign": "Tabella tal-Ballut Bajdan Mdendla mal-Ħajt",
  "block.minecraft.pale_oak_wall_sign": "Tabella tal-Ballut Bajdan mal-Ħajt",
  "block.minecraft.pale_oak_wood": "Injam tal-Ballut Bajdan",
  "block.minecraft.pearlescent_froglight": "Żradawl Perlexxenti",
  "block.minecraft.peony": "Peony",
  "block.minecraft.petrified_oak_slab": "Ċangun tal-Ballut Imħaġġar",
  "block.minecraft.piglin_head": "Ras il-Ħnejżer",
  "block.minecraft.piglin_wall_head": "Ras il-Ħnejżer mal-Ħajt",
  "block.minecraft.pink_banner": "Strixxun Roża",
  "block.minecraft.pink_bed": "Sodda Roża",
  "block.minecraft.pink_candle": "Xemgħa roża",
  "block.minecraft.pink_candle_cake": "Kejk b'Xemgħa Roża",
  "block.minecraft.pink_carpet": "Tapit Roża",
  "block.minecraft.pink_concrete": "Konkrit Roża",
  "block.minecraft.pink_concrete_powder": "Konkrit Imtarrab Roża",
  "block.minecraft.pink_glazed_terracotta": "Terrakotta Żmaltata Roża",
  "block.minecraft.pink_petals": "Loqom Roża",
  "block.minecraft.pink_shulker_box": "Kaxxa Qoxrana Roża",
  "block.minecraft.pink_stained_glass": "Ħġieġ Miżbugħ Roża",
  "block.minecraft.pink_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Roża",
  "block.minecraft.pink_terracotta": "Terrakotta Roża",
  "block.minecraft.pink_tulip": "Tulip Roża",
  "block.minecraft.pink_wool": "Suf Roża",
  "block.minecraft.piston": "Pistun",
  "block.minecraft.piston_head": "Ras il-Pistun",
  "block.minecraft.pitcher_crop": "Għallet il-Buqxtiela",
  "block.minecraft.pitcher_plant": "Xitlet il-Buqxtiela",
  "block.minecraft.player_head": "Ras il-Lagħbi",
  "block.minecraft.player_head.named": "Ras ta' %s",
  "block.minecraft.player_wall_head": "Ras tal-Ħajt tal-Lagħbi",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Dripstone bil-ponta",
  "block.minecraft.polished_andesite": "Andesite Illustrat",
  "block.minecraft.polished_andesite_slab": "Ċangun tal-Andesit Illustrat",
  "block.minecraft.polished_andesite_stairs": "Taraġ tal-Andesit Illustrat",
  "block.minecraft.polished_basalt": "Bażalt Illostrat",
  "block.minecraft.polished_blackstone": "Ġebla Sewda Illostrata",
  "block.minecraft.polished_blackstone_brick_slab": "Ċangatura tal-Ġebla Sewda Illostrata",
  "block.minecraft.polished_blackstone_brick_stairs": "Taraġ tal-Briks tal-Ġebla Sewda Illostrata",
  "block.minecraft.polished_blackstone_brick_wall": "Ħajt tal-Briks tal-Ġebel Sewda Illostrata",
  "block.minecraft.polished_blackstone_bricks": "Briksiet tal-Ġebla Sewda Illostrata",
  "block.minecraft.polished_blackstone_button": "Buttuna tal-Ġeblasewda Illustrata",
  "block.minecraft.polished_blackstone_pressure_plate": "Pjanċa tal-Ġeblasewda Illustrata",
  "block.minecraft.polished_blackstone_slab": "Ċangun tal-Ġeblasewda Illustrat",
  "block.minecraft.polished_blackstone_stairs": "Taraġ tal-Ġeblasewda Illustrat",
  "block.minecraft.polished_blackstone_wall": "Ħajt tal-Ġebla Sewda Illostrata",
  "block.minecraft.polished_deepslate": "Lavanja Illustrata",
  "block.minecraft.polished_deepslate_slab": "Ċangun tal-Lavanja Illustrat",
  "block.minecraft.polished_deepslate_stairs": "Taraġ tal-Lavanja Illustrat",
  "block.minecraft.polished_deepslate_wall": "Ċint tal-Lavanja Illustrat",
  "block.minecraft.polished_diorite": "Diorite Illustrat",
  "block.minecraft.polished_diorite_slab": "Ċangun tad-Dijorit Illustrat",
  "block.minecraft.polished_diorite_stairs": "Taraġ tad-Dijorit Illustrat",
  "block.minecraft.polished_granite": "Granit Illustrat",
  "block.minecraft.polished_granite_slab": "Ċangun tal-Granit Illustrat",
  "block.minecraft.polished_granite_stairs": "Taraġ tal-Granit Illustrat",
  "block.minecraft.polished_tuff": "Tufu Illustrat",
  "block.minecraft.polished_tuff_slab": "Ċangun tat-Tufu Illustrat",
  "block.minecraft.polished_tuff_stairs": "Taraġ tat-Tufu Illustrat",
  "block.minecraft.polished_tuff_wall": "Ċint tat-Tufu Illustrat",
  "block.minecraft.poppy": "Peprina",
  "block.minecraft.potatoes": "Patata",
  "block.minecraft.potted_acacia_sapling": "Qasrija tal-Isġajra tal-Akaċja",
  "block.minecraft.potted_allium": "Qasrija tal-Allju",
  "block.minecraft.potted_azalea_bush": "Qasrija tal-Ażalea",
  "block.minecraft.potted_azure_bluet": "Qasrija tal-Beżżulett il-Baqra",
  "block.minecraft.potted_bamboo": "Qasrija tal-Bambù",
  "block.minecraft.potted_birch_sapling": "Qasrija tal-Isġajra tal-Betula",
  "block.minecraft.potted_blue_orchid": "Qasrija tal-Orkideja Blu",
  "block.minecraft.potted_brown_mushroom": "Qasrija tal-Faqqiegħ Kannella",
  "block.minecraft.potted_cactus": "Qasrija tal-Kaktus",
  "block.minecraft.potted_cherry_sapling": "Qasrija tal-Isġajra taċ-Ċirasa",
  "block.minecraft.potted_closed_eyeblossom": "Qasrija taż-Żahret il-Għajn Magħluqa",
  "block.minecraft.potted_cornflower": "Qasrija tal-Wardet il-Qamħ",
  "block.minecraft.potted_crimson_fungus": "Qasrija tal-Fungi Krimżi",
  "block.minecraft.potted_crimson_roots": "Qasrija tal-Għeruq Krimżi",
  "block.minecraft.potted_dandelion": "Qasrija tal-Lelluxa",
  "block.minecraft.potted_dark_oak_sapling": "Qasrija tal-Isġajra tal-Ballut Dagħmi",
  "block.minecraft.potted_dead_bush": "Qasrija tax-Xitla Niexfa",
  "block.minecraft.potted_fern": "Qasrija tal-Felċa",
  "block.minecraft.potted_flowering_azalea_bush": "Qasrija tal-Ażalea Mwarrda",
  "block.minecraft.potted_golden_dandelion": "Qasrija tal-Lelluxa Dehbija",
  "block.minecraft.potted_jungle_sapling": "Qasrija tal-Isġajra tal-Ġungla",
  "block.minecraft.potted_lily_of_the_valley": "Qasrija tal-Ġilju",
  "block.minecraft.potted_mangrove_propagule": "Qasrija tal-Ferħa tal-Mangrovja",
  "block.minecraft.potted_oak_sapling": "Qasrija tal-Isġajra tal-Ballut",
  "block.minecraft.potted_open_eyeblossom": "Qasrija taż-Żahret il-Għajn Miftuħa",
  "block.minecraft.potted_orange_tulip": "Qasrija tat-Tulipa Oranġjo",
  "block.minecraft.potted_oxeye_daisy": "Qasrija tal-Margerita",
  "block.minecraft.potted_pale_oak_sapling": "Qasrija tal-Isġajra tal-Ballut Bajdan",
  "block.minecraft.potted_pink_tulip": "Qasrija tat-Tulipa Roża",
  "block.minecraft.potted_poppy": "Qasrija tal-Peprina",
  "block.minecraft.potted_red_mushroom": "Qasrija tal-Faqqiegħ Aħmar",
  "block.minecraft.potted_red_tulip": "Qasrija tat-Tulipa Ħamra",
  "block.minecraft.potted_spruce_sapling": "Qasrija tal-Isġajra tal-Abit",
  "block.minecraft.potted_torchflower": "Qasrija tal-Fjurtorċa",
  "block.minecraft.potted_warped_fungus": "Qasrija tal-Fungi Stramb",
  "block.minecraft.potted_warped_roots": "Qasrija tal-Għeruq Stramb",
  "block.minecraft.potted_white_tulip": "Qasrija tat-Tulipa Bajda",
  "block.minecraft.potted_wither_rose": "Qasrija tal-Warda Debbiela",
  "block.minecraft.powder_snow": "Borra Mtarrba",
  "block.minecraft.powder_snow_cauldron": "Trab Borra Kaldarun",
  "block.minecraft.powered_rail": "Linji Mixgħulin",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Ċangun tal-Briks Priżmarinf",
  "block.minecraft.prismarine_brick_stairs": "Taraġ tal-Briks Priżmarin",
  "block.minecraft.prismarine_bricks": "Briks tal-Prismarine",
  "block.minecraft.prismarine_slab": "Ċangun Priżmarin",
  "block.minecraft.prismarine_stairs": "Taraġ Priżmarin",
  "block.minecraft.prismarine_wall": "Ċint Priżmarin",
  "block.minecraft.pumpkin": "Qargħa Ħamra",
  "block.minecraft.pumpkin_stem": "Zokk tal-Qargħa Ħamra",
  "block.minecraft.purple_banner": "Strixxun Vjola",
  "block.minecraft.purple_bed": "Sodda Vjola",
  "block.minecraft.purple_candle": "Xemgħa vjola",
  "block.minecraft.purple_candle_cake": "Kejk b'Xemgħa Vjola",
  "block.minecraft.purple_carpet": "Tapit Vjola",
  "block.minecraft.purple_concrete": "Konkrit Vjola",
  "block.minecraft.purple_concrete_powder": "Konkrit Imtarrab Vjola",
  "block.minecraft.purple_glazed_terracotta": "Terrakotta bi tleqqija vjola",
  "block.minecraft.purple_shulker_box": "Kaxxa Qoxrana Vjola",
  "block.minecraft.purple_stained_glass": "Ħġieġ Miżbugħ Vjola",
  "block.minecraft.purple_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Vjola",
  "block.minecraft.purple_terracotta": "Terrakotta Vjola",
  "block.minecraft.purple_wool": "Suf Vjola",
  "block.minecraft.purpur_block": "Blokka tal-Purpur",
  "block.minecraft.purpur_pillar": "Pilastru tal-Purpur",
  "block.minecraft.purpur_slab": "Ċangun tal-Purpur",
  "block.minecraft.purpur_stairs": "Taraġ tal-Purpur",
  "block.minecraft.quartz_block": "Blokka tal-Kwarz",
  "block.minecraft.quartz_bricks": "Briks tal-Kwarz",
  "block.minecraft.quartz_pillar": "Pilastru tal-Kwarz",
  "block.minecraft.quartz_slab": "Ċangun tal-Kwarz",
  "block.minecraft.quartz_stairs": "Taraġ tal-Kwarz",
  "block.minecraft.rail": "Linji tat-Trakk",
  "block.minecraft.raw_copper_block": "Blokka tar-Ram mhux Maħdum",
  "block.minecraft.raw_gold_block": "Blokka tal-Deheb mhux Maħdum",
  "block.minecraft.raw_iron_block": "Blokka tal-Ħadid mhux Maħdum",
  "block.minecraft.red_banner": "Strixxun Aħmar",
  "block.minecraft.red_bed": "Sodda Ħamra",
  "block.minecraft.red_candle": "Xemgħa ħamra",
  "block.minecraft.red_candle_cake": "Kejk b'Xemgħa Ħamra",
  "block.minecraft.red_carpet": "Tapit Aħmar",
  "block.minecraft.red_concrete": "Konkrit Aħmar",
  "block.minecraft.red_concrete_powder": "Konkrit Imtarrab Aħmar",
  "block.minecraft.red_glazed_terracotta": "Terrakotta Żmaltata Ħamra",
  "block.minecraft.red_mushroom": "Faqqiegħ Aħmar",
  "block.minecraft.red_mushroom_block": "Blokk tal-Faqqiegħ Aħmar",
  "block.minecraft.red_nether_brick_slab": "Ċangun tal-Briks Taħħata Ħomor",
  "block.minecraft.red_nether_brick_stairs": "Taraġ tal-Briks Taħħata Ħomor",
  "block.minecraft.red_nether_brick_wall": "Ċint tal-Briks Taħħata Ħomor",
  "block.minecraft.red_nether_bricks": "Briks Taħħata Ħomor",
  "block.minecraft.red_sand": "Ramel Aħmar",
  "block.minecraft.red_sandstone": "Ġebel Aħmar tal-Franka",
  "block.minecraft.red_sandstone_slab": "Ċangun tal-Ġebel Aħmar tal-Franka",
  "block.minecraft.red_sandstone_stairs": "Taraġ tal-Ġebel Aħmar tal-Franka",
  "block.minecraft.red_sandstone_wall": "Ċint tal-Franka Ħamra",
  "block.minecraft.red_shulker_box": "Kaxxa Qoxrana Ħamra",
  "block.minecraft.red_stained_glass": "Ħġieġ Miżbugħ Aħmar",
  "block.minecraft.red_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Ħamra",
  "block.minecraft.red_terracotta": "Terrakotta Ħamra",
  "block.minecraft.red_tulip": "Tulip Ħamra",
  "block.minecraft.red_wool": "Suf Aħmar",
  "block.minecraft.redstone_block": "Blokka tar-Redstone",
  "block.minecraft.redstone_lamp": "Lampa tar-Redstone",
  "block.minecraft.redstone_ore": "Sigħat tar-Redstone",
  "block.minecraft.redstone_torch": "Torċa tar-Redstone",
  "block.minecraft.redstone_wall_torch": "Dawwal Ġeblaħamra mal-Ħajt",
  "block.minecraft.redstone_wire": "Linja Ġeblaħamra",
  "block.minecraft.reinforced_deepslate": "Lavanja Msaħħa",
  "block.minecraft.repeater": "Dajowd tar-Redstone",
  "block.minecraft.repeating_command_block": "Blokka tal-Kodiċi Tirrepeti",
  "block.minecraft.resin_block": "Blokka tar-Reżina",
  "block.minecraft.resin_brick_slab": "Ċangun tal-Briks tar-Reżina",
  "block.minecraft.resin_brick_stairs": "Taraġ tal-Briks tar-Reżina",
  "block.minecraft.resin_brick_wall": "Ċint tal-Briks tar-Reżina",
  "block.minecraft.resin_bricks": "Briks tar-Reżina",
  "block.minecraft.resin_clump": "Ċappa Reżina",
  "block.minecraft.respawn_anchor": "Ankra Mġarrba",
  "block.minecraft.rooted_dirt": "Ħamrija Megħruqa",
  "block.minecraft.rose_bush": "Xitla tal-Ward",
  "block.minecraft.sand": "Ramel",
  "block.minecraft.sandstone": "Ġebel tal-Franka",
  "block.minecraft.sandstone_slab": "Ċangun tal-Franka",
  "block.minecraft.sandstone_stairs": "Taraġ tal-Franka",
  "block.minecraft.sandstone_wall": " Ċint tal-Franka",
  "block.minecraft.scaffolding": "Armar",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Ħaffief l-Iskulk",
  "block.minecraft.sculk_sensor": "Sculk Ditekter",
  "block.minecraft.sculk_shrieker": "Għajjat l-Iskulk",
  "block.minecraft.sculk_vein": "Vinet l-Iskulk",
  "block.minecraft.sea_lantern": "Mixegħela tal-Baħar",
  "block.minecraft.sea_pickle": "Ħjar il-Baħar",
  "block.minecraft.seagrass": "Ħaxix il-baħar",
  "block.minecraft.set_spawn": "Post tat-Tfaċċar Magħżul",
  "block.minecraft.short_dry_grass": "Ħaxix Niexef Qasir",
  "block.minecraft.short_grass": "Ħaxix Qasir",
  "block.minecraft.shroomlight": "Faqqiegħ li Jixgħel",
  "block.minecraft.shulker_box": "Kaxxa ta ' shulker",
  "block.minecraft.skeleton_skull": "Ras ta' Skeletru",
  "block.minecraft.skeleton_wall_skull": "Ras l-Iskeletru mal-Ħajt",
  "block.minecraft.slime_block": "Blokka tal-Ħama",
  "block.minecraft.small_amethyst_bud": "Bud Amethyst Żgħir",
  "block.minecraft.small_dripleaf": "Werqatra Żgħira",
  "block.minecraft.smithing_table": "Mejda tal-Ħaddied",
  "block.minecraft.smoker": "Affumikatur",
  "block.minecraft.smooth_basalt": "Basalt Lixx",
  "block.minecraft.smooth_quartz": "Blokka tal-Kwarz Lixxa",
  "block.minecraft.smooth_quartz_slab": "Ċangun tal-Kwarz Lixx",
  "block.minecraft.smooth_quartz_stairs": "Taraġ tal-Kwarz Lixx",
  "block.minecraft.smooth_red_sandstone": "Ġebel Aħmar tal-Franka Lixx",
  "block.minecraft.smooth_red_sandstone_slab": "Ċangun tal-Franka Ħamra Lixxa",
  "block.minecraft.smooth_red_sandstone_stairs": "Taraġ tal-Franka Ħamra Lixxa",
  "block.minecraft.smooth_sandstone": "Ġebel tal-Franka Lixx",
  "block.minecraft.smooth_sandstone_slab": "Ċangun tal-Franka Lixxa",
  "block.minecraft.smooth_sandstone_stairs": "Taraġ tal-Franka Lixxa",
  "block.minecraft.smooth_stone": "Ġebel Lixx",
  "block.minecraft.smooth_stone_slab": "Ċangun tal-Ġebel Lixx",
  "block.minecraft.sniffer_egg": "Bajda tax-Xammiem",
  "block.minecraft.snow": "Borra",
  "block.minecraft.snow_block": "Blokka Borra",
  "block.minecraft.soul_campfire": "Nar tal-Kamp tar-Ruħ",
  "block.minecraft.soul_fire": "Nar tar-Ruħ",
  "block.minecraft.soul_lantern": "Fanal tar-Ruħ",
  "block.minecraft.soul_sand": "Trab tal-Erwieħ",
  "block.minecraft.soul_soil": "Ħamrija tar-Ruħ",
  "block.minecraft.soul_torch": "Ruħ Torċa",
  "block.minecraft.soul_wall_torch": "Qafla tal-Ħajt tar-Ruħ",
  "block.minecraft.spawn.not_valid": "M'għandek l-ebda sodda jew ankra rikarikata li ġiet rikarigata, jew ġiet imxekkla",
  "block.minecraft.spawner": "Maqfas il-Mostri",
  "block.minecraft.spawner.desc1": "Tuża l-Bajda Sawran:",
  "block.minecraft.spawner.desc2": "Tagħżel Tip il-Bhejjem",
  "block.minecraft.sponge": "Sponża",
  "block.minecraft.spore_blossom": "Nwara Sporuża",
  "block.minecraft.spruce_button": "Buttuna tal-Abit",
  "block.minecraft.spruce_door": "Bieb tal-Arżnu",
  "block.minecraft.spruce_fence": "Ċint tal-Arżnu",
  "block.minecraft.spruce_fence_gate": "Grada tal-Arżnu",
  "block.minecraft.spruce_hanging_sign": "Tabella Mdendla tal-Abit",
  "block.minecraft.spruce_leaves": "Weraq tal-Arżnu",
  "block.minecraft.spruce_log": "Zokk tal-Abit",
  "block.minecraft.spruce_planks": "Twavel tal-Abit",
  "block.minecraft.spruce_pressure_plate": "Pjanċa tal-Abit",
  "block.minecraft.spruce_sapling": "Żgħar tal-Arżnu",
  "block.minecraft.spruce_shelf": "Xkaffa tal-Abit",
  "block.minecraft.spruce_sign": "Tabella tal-Abit",
  "block.minecraft.spruce_slab": "Ċangun tal-Abit",
  "block.minecraft.spruce_stairs": "Taraġ tal-Abit",
  "block.minecraft.spruce_trapdoor": "Bokkaport tal-Abit",
  "block.minecraft.spruce_wall_hanging_sign": "Tabella Mdendla tal-Abit mal-Ħajt",
  "block.minecraft.spruce_wall_sign": "Tabella tal-Abit mal-Ħajt",
  "block.minecraft.spruce_wood": "Injam tal-Arżnu",
  "block.minecraft.sticky_piston": "Pistun Iweħħel",
  "block.minecraft.stone": "Ġebel",
  "block.minecraft.stone_brick_slab": "Ċangun tal-Briks tal-Ġebel",
  "block.minecraft.stone_brick_stairs": "Taraġ tal-Briks tal-Ġebel",
  "block.minecraft.stone_brick_wall": "Ħajt tal-Briks tal-Ġebel",
  "block.minecraft.stone_bricks": "Briks tal-Ġebel",
  "block.minecraft.stone_button": "Buttuna tal-Ġebel",
  "block.minecraft.stone_pressure_plate": "Pjanċa tal-Ġebel",
  "block.minecraft.stone_slab": "Ċangun tal-Ġebel",
  "block.minecraft.stone_stairs": "Taraġ tal-Ġebel",
  "block.minecraft.stonecutter": "Moqtiegħ",
  "block.minecraft.stripped_acacia_log": "Zokk tal-Akaċja Mqaxxar",
  "block.minecraft.stripped_acacia_wood": "Injam tal-Akaċja Mqaxxar",
  "block.minecraft.stripped_bamboo_block": "Blokk tal-Bambù Mqaxxar",
  "block.minecraft.stripped_birch_log": "Zokk tal-Betula Mqaxxar",
  "block.minecraft.stripped_birch_wood": "Injam tal-Betula Mqaxxar",
  "block.minecraft.stripped_cherry_log": "Zokk taċ-Ċirasa Mqaxxar",
  "block.minecraft.stripped_cherry_wood": "Injam taċ-Ċirasa Mqaxxar",
  "block.minecraft.stripped_crimson_hyphae": "Ħajfi Krimżi Imqaxxar",
  "block.minecraft.stripped_crimson_stem": "Zokk Krimżi Imqaxxar",
  "block.minecraft.stripped_dark_oak_log": "Zokk tal-Ballut Dagħmi Imqaxxar",
  "block.minecraft.stripped_dark_oak_wood": "Injam tal-Ballut Dagħmi Imqaxxar",
  "block.minecraft.stripped_jungle_log": "Zokk tal-Ġungla Mqaxxar",
  "block.minecraft.stripped_jungle_wood": "Injam tal-Ġungla Mqaxxar",
  "block.minecraft.stripped_mangrove_log": "Zokk tal-Mangrovja Mqaxxar",
  "block.minecraft.stripped_mangrove_wood": "Injam tal-Mangrovja Mqaxxar",
  "block.minecraft.stripped_oak_log": "Zokk tal-Ballut Imqaxxar",
  "block.minecraft.stripped_oak_wood": "Injam tal-Ballut Imqaxxar",
  "block.minecraft.stripped_pale_oak_log": "Zokk tal-Ballut Bajdan Imqaxxar",
  "block.minecraft.stripped_pale_oak_wood": "Injam tal-Ballut Bajdan Imqaxxar",
  "block.minecraft.stripped_spruce_log": "Zokk tal-Abit Mqaxxar",
  "block.minecraft.stripped_spruce_wood": "Injam tal-Abit Mqaxxar",
  "block.minecraft.stripped_warped_hyphae": "Ħajfi Stramb Imqaxxar",
  "block.minecraft.stripped_warped_stem": "Zokk Stramb Imqaxxar",
  "block.minecraft.structure_block": "Blokka tal-Istruttura",
  "block.minecraft.structure_void": "Struttura Batla",
  "block.minecraft.sugar_cane": "Kannamieli",
  "block.minecraft.sunflower": "Ġirasol",
  "block.minecraft.suspicious_gravel": "Żrar Dubjuż",
  "block.minecraft.suspicious_sand": "Ramel Dubjuż",
  "block.minecraft.sweet_berry_bush": "Arbuxxell tal-Frott Ħelu",
  "block.minecraft.tall_dry_grass": "Ħaxix Twil Niexef",
  "block.minecraft.tall_grass": "Ħaxix twil",
  "block.minecraft.tall_seagrass": "Ħaxix il-Baħar Twil",
  "block.minecraft.target": "Mira",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Blokka tat-Testjar",
  "block.minecraft.test_instance_block": "Blokka tal-Istanza tat-Test",
  "block.minecraft.tinted_glass": "Ħġieġ Opak",
  "block.minecraft.tnt": "Splussivi",
  "block.minecraft.tnt.disabled": "Splużjonijiet tat-Tritlu huma mitfija",
  "block.minecraft.torch": "Torċa",
  "block.minecraft.torchflower": "Fjurtorċa",
  "block.minecraft.torchflower_crop": "Zokk tal-Fjurtorċa",
  "block.minecraft.trapped_chest": "Senduq Trappola",
  "block.minecraft.trial_spawner": "Maqfas il-Ġarb",
  "block.minecraft.tripwire": "Trappola",
  "block.minecraft.tripwire_hook": "Ganċ tat-Trappola",
  "block.minecraft.tube_coral": "Qroll tat-Tubu",
  "block.minecraft.tube_coral_block": "Blokka tal-Qroll tat-Tubu",
  "block.minecraft.tube_coral_fan": "Fann tat-Tubu",
  "block.minecraft.tube_coral_wall_fan": "Fann tal-Ħajt tal-Qroll tat-Tubu",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Ċangun tal-Briks tat-Tufu",
  "block.minecraft.tuff_brick_stairs": "Taraġ tal-Briks tat-Tufu",
  "block.minecraft.tuff_brick_wall": "Ċint tal-Briks tat-Tufu",
  "block.minecraft.tuff_bricks": "Briks tat-Tufu",
  "block.minecraft.tuff_slab": "Ċangun tat-Tufu",
  "block.minecraft.tuff_stairs": "Taraġ tat-Tufu",
  "block.minecraft.tuff_wall": "Ħajt tat-Tufu",
  "block.minecraft.turtle_egg": "Bajda tal-Fekruna",
  "block.minecraft.twisting_vines": "Dwieli li Jduru",
  "block.minecraft.twisting_vines_plant": "Pjanta tad-Dwieli li Jduru",
  "block.minecraft.vault": "Kaxxaforti",
  "block.minecraft.verdant_froglight": "Żradawl Ħadranija",
  "block.minecraft.vine": "Dwieli",
  "block.minecraft.void_air": "Arja Nulla",
  "block.minecraft.wall_torch": "Dawwal mal-Ħajt",
  "block.minecraft.warped_button": "Buttuna Stramba",
  "block.minecraft.warped_door": "Bieb Stramb",
  "block.minecraft.warped_fence": "Ċint Stramb",
  "block.minecraft.warped_fence_gate": "Grada Stramba",
  "block.minecraft.warped_fungus": "Fungi Stramb",
  "block.minecraft.warped_hanging_sign": "Tabella Mdendla Mgħawġa",
  "block.minecraft.warped_hyphae": "Ħajfi Stramb",
  "block.minecraft.warped_nylium": "Njlium Stramb",
  "block.minecraft.warped_planks": "Planki Strambi",
  "block.minecraft.warped_pressure_plate": "Pjanċa tal-Pressjoni Stramb",
  "block.minecraft.warped_roots": "Għeruq Stramb",
  "block.minecraft.warped_shelf": "Xkaffa Mgħawġa",
  "block.minecraft.warped_sign": "Tabella Stramba",
  "block.minecraft.warped_slab": "Nofs Planki Strambi",
  "block.minecraft.warped_stairs": "Taraġ Stramb",
  "block.minecraft.warped_stem": "Zokk Stramb",
  "block.minecraft.warped_trapdoor": "Bieba Stramba",
  "block.minecraft.warped_wall_hanging_sign": "Tabella tal-Ħajt Mdendla Mgħawġa",
  "block.minecraft.warped_wall_sign": "Tabella Stramba mal-Ħajt",
  "block.minecraft.warped_wart_block": "Blokka tal-Felula Stramb",
  "block.minecraft.water": "Ilma",
  "block.minecraft.water_cauldron": "Kaldarun tal-Ilma",
  "block.minecraft.waxed_chiseled_copper": "Ram Imnaqqax bix-Xema'",
  "block.minecraft.waxed_copper_bars": "Vireg tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_block": "Blokka Ram Imxamma'",
  "block.minecraft.waxed_copper_bulb": "Bozza tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_chain": "Katina tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_chest": "Senduq tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_door": "Bieb tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_grate": "Gradilja tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_lantern": "Fanal tar-Ram Imxamma'",
  "block.minecraft.waxed_copper_trapdoor": "Bokkaport tar-Ram Imxamma'",
  "block.minecraft.waxed_cut_copper": "Ram Maqtugħ xema'",
  "block.minecraft.waxed_cut_copper_slab": "Slab tar-ram maqtugħ mix-xama'",
  "block.minecraft.waxed_cut_copper_stairs": "Taraġ maqtugħ tar-Ram tax-Xama'",
  "block.minecraft.waxed_exposed_chiseled_copper": "Ram Imnaqqax Espost bix-Xema'",
  "block.minecraft.waxed_exposed_copper": "Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_copper_bars": "Vireg tar-Ram Esposti Mxamma'",
  "block.minecraft.waxed_exposed_copper_bulb": "Bozza tar-Ram Esposta Mxamma'",
  "block.minecraft.waxed_exposed_copper_chain": "Katina tar-Ram Esposta Mxamma'",
  "block.minecraft.waxed_exposed_copper_chest": "Senduq tar-Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_copper_door": "Bieb tar-Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_copper_grate": "Gradilja tar-Ram Esposta Mxamma'",
  "block.minecraft.waxed_exposed_copper_lantern": "Fanal tar-Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Bokkaport tar-Ram Espost Imxamma'",
  "block.minecraft.waxed_exposed_cut_copper": "Ram Maqtugħ Espost Imxamma'",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Ċangun tar-Ram Maqtugħ Espost Imxamma'",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Taraġ tar-Ram Maqtugħ Espost Imxamma'",
  "block.minecraft.waxed_exposed_lightning_rod": "Virga tas-Sajjetti Esposta Mxamma'",
  "block.minecraft.waxed_lightning_rod": "Virga tas-Sajjetti Mxamma'",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Ram Imnaqqax Imsadda Mxamma'",
  "block.minecraft.waxed_oxidized_copper": "Ram Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_copper_bars": "Vireg tar-Ram Imsaddin Imxamma'",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bozza tar-Ram Imsadda Mxamma'",
  "block.minecraft.waxed_oxidized_copper_chain": "Katina tar-Ram Imsadda Mxamma'",
  "block.minecraft.waxed_oxidized_copper_chest": "Senduq tar-Ram Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_copper_door": "Bieb tar-Ram Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statwa tal-Ġġantin tar-Ram Imsadda Mxamma'",
  "block.minecraft.waxed_oxidized_copper_grate": "Gradilja tar-Ram Imsadda Mxamma'",
  "block.minecraft.waxed_oxidized_copper_lantern": "Fanal tar-Ram Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Bokkaport tar-Ram Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_cut_copper": "Ram Maqtugħ Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Ċangun tar-Ram Maqtugħ Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Taraġ tar-Ram Maqtugħ Imsaddad Imxamma'",
  "block.minecraft.waxed_oxidized_lightning_rod": "Virga tas-Sajjetti Imsaddin Imxamma'",
  "block.minecraft.waxed_weathered_chiseled_copper": "Ram Imnaqqax Mherri bix-Xema'",
  "block.minecraft.waxed_weathered_copper": "Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_bars": "Vireg tar-Ram Mherrin Mxamma'",
  "block.minecraft.waxed_weathered_copper_bulb": "Bozza tar-Ram Mherrija Mxamma'",
  "block.minecraft.waxed_weathered_copper_chain": "Katina tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_chest": "Senduq tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_door": "Bieb tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_grate": "Gradilja tar-Ram Mherrija Mxamma'",
  "block.minecraft.waxed_weathered_copper_lantern": "Fanal tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Bokkaport tar-Ram Mherri Mxamma'",
  "block.minecraft.waxed_weathered_cut_copper": "Ram Maqtugħ Mherri Mxamma'",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Ċangun tar-Ram Maqtugħ Mheri Mxamma'",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Taraġ tar-Ram Maqtugħ Mherri Mxamma'",
  "block.minecraft.waxed_weathered_lightning_rod": "Virga tas-Sajjetti Mherrijin Imxamma'",
  "block.minecraft.weathered_chiseled_copper": "Ram Imnaqqax Imherri",
  "block.minecraft.weathered_copper": "Ram Mherri",
  "block.minecraft.weathered_copper_bars": "Vireg tar-Ram Mherrijin",
  "block.minecraft.weathered_copper_bulb": "Bozza tar-Ram Mherrija",
  "block.minecraft.weathered_copper_chain": "Katina tar-Ram Mherrija",
  "block.minecraft.weathered_copper_chest": "Senduq tar-Ram Mherri",
  "block.minecraft.weathered_copper_door": "Bieb tar-Ram Mherri",
  "block.minecraft.weathered_copper_golem_statue": "Statwa tal-Ġgantin tar-Ram Mherrija",
  "block.minecraft.weathered_copper_grate": "Gradilja tar-Ram Mherrija",
  "block.minecraft.weathered_copper_lantern": "Fanal tar-Ram Mherri",
  "block.minecraft.weathered_copper_trapdoor": "Bokkaport tar-Ram Mherri",
  "block.minecraft.weathered_cut_copper": "Ram maqtugħ imfewwek",
  "block.minecraft.weathered_cut_copper_slab": "Slab tar-ram maqtugħ imteeħed",
  "block.minecraft.weathered_cut_copper_stairs": "Taraġ tar-ram maqtugħ imteffi",
  "block.minecraft.weathered_lightning_rod": "Virga tas-Sajjetti Mherrijin Mxamma'",
  "block.minecraft.weeping_vines": "Dwieli tal-Biki",
  "block.minecraft.weeping_vines_plant": "Pjanti tad-Dielja Biki",
  "block.minecraft.wet_sponge": "Sponża Mxarba",
  "block.minecraft.wheat": "Qamħ",
  "block.minecraft.white_banner": "Strixxun Abjad",
  "block.minecraft.white_bed": "Sodda Bajda",
  "block.minecraft.white_candle": "Xemgħa bajda",
  "block.minecraft.white_candle_cake": "Kejk b'Xemgħa Bajda",
  "block.minecraft.white_carpet": "Tapit abjad",
  "block.minecraft.white_concrete": "Konkrit Abjad",
  "block.minecraft.white_concrete_powder": "Konkrit Imtarrab Abjad",
  "block.minecraft.white_glazed_terracotta": "Terrakotta Żmaltata Bajda",
  "block.minecraft.white_shulker_box": "Kaxxa Qoxrana Bajda",
  "block.minecraft.white_stained_glass": "Ħġieġ Miżbugħ Abjad",
  "block.minecraft.white_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Bajda Ċara",
  "block.minecraft.white_terracotta": "Terrakotta Bajda",
  "block.minecraft.white_tulip": "Tulip Bajda",
  "block.minecraft.white_wool": "Suf Abjad",
  "block.minecraft.wildflowers": "Fjuri Selvaġġi",
  "block.minecraft.wither_rose": "Warda Debbiela",
  "block.minecraft.wither_skeleton_skull": "Ras ta' Skeletru tal-Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Ras l-Iskeletru Debbiel mal-Ħajt",
  "block.minecraft.yellow_banner": "Strixxun Isfar",
  "block.minecraft.yellow_bed": "Sodda Safra",
  "block.minecraft.yellow_candle": "Xemgħa safra",
  "block.minecraft.yellow_candle_cake": "Kejk b'Xemgħa Safra",
  "block.minecraft.yellow_carpet": "Tapit Isfar",
  "block.minecraft.yellow_concrete": "Konkrit Isfar",
  "block.minecraft.yellow_concrete_powder": "Konkrit Imtarrab Isfar",
  "block.minecraft.yellow_glazed_terracotta": "Terrakotta bit-tleqqija safrani",
  "block.minecraft.yellow_shulker_box": "Kaxxa Qoxrana Safra",
  "block.minecraft.yellow_stained_glass": "Ħġieġ Miżbugħ Isfar",
  "block.minecraft.yellow_stained_glass_pane": "Ħġieġa Ċatta Miżbugħha Safra",
  "block.minecraft.yellow_terracotta": "Terrakotta Safra",
  "block.minecraft.yellow_wool": "Suf Isfar",
  "block.minecraft.zombie_head": "Ras ta' Mostru",
  "block.minecraft.zombie_wall_head": "Ras iż-Żombi mal-Ħajt",
  "item.minecraft.acacia_boat": "Dgħajsa tal-Akaċja",
  "item.minecraft.acacia_chest_boat": "Dgħajsa tal-Akaċja b'Senduq",
  "item.minecraft.allay_spawn_egg": "Bajda Sawrana tat-Taffa",
  "item.minecraft.amethyst_shard": "Biċċa tal-Ametista",
  "item.minecraft.angler_pottery_shard": "Xaqqufa b'Qasba",
  "item.minecraft.angler_pottery_sherd": "Xaqqufa b'Qasba",
  "item.minecraft.apple": "Tuffieħa",
  "item.minecraft.archer_pottery_shard": "Xaqqufa b’Qaws",
  "item.minecraft.archer_pottery_sherd": "Xaqqufa b’Qaws",
  "item.minecraft.armadillo_scute": "Skuta t'Armadill",
  "item.minecraft.armadillo_spawn_egg": "Bajda Sawrana tal-Armadill",
  "item.minecraft.armor_stand": "Stand tal-Armar",
  "item.minecraft.arms_up_pottery_shard": "Xaqqufa b’Dirgħajn ‘il Fuq",
  "item.minecraft.arms_up_pottery_sherd": "Xaqqufa b’Dirgħajn ‘il Fuq",
  "item.minecraft.arrow": "Vleġġa",
  "item.minecraft.axolotl_bucket": "Barmil ta 'Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Bajd ta 'Axolotl",
  "item.minecraft.baked_potato": "Patata Msajra",
  "item.minecraft.bamboo_chest_raft": "Ċattra tal-Bambù b'Senduq",
  "item.minecraft.bamboo_raft": "Ċattra tal-Bambù",
  "item.minecraft.bat_spawn_egg": "Bajda Sawrana tal-Farfett il-lejl",
  "item.minecraft.bee_spawn_egg": "Bajda Sawrana tan-Naħla",
  "item.minecraft.beef": "Ċanga Nejja",
  "item.minecraft.beetroot": "Pitrava",
  "item.minecraft.beetroot_seeds": "Żerriegħa tal-Pitravi",
  "item.minecraft.beetroot_soup": "Soppa tal-Pitravi",
  "item.minecraft.birch_boat": "Dgħajsa tal-Betula",
  "item.minecraft.birch_chest_boat": "Dgħajsa tal-Betula b'Senduq",
  "item.minecraft.black_bundle": "Sorra Sewda",
  "item.minecraft.black_dye": "Żebgħa Sewda",
  "item.minecraft.black_harness": "Xedd Iswed",
  "item.minecraft.blade_pottery_shard": "Xaqqufa b’Xafra",
  "item.minecraft.blade_pottery_sherd": "Xaqqufa b’Xafra",
  "item.minecraft.blaze_powder": "Trab tan-Nar",
  "item.minecraft.blaze_rod": "Virga tan-Nar",
  "item.minecraft.blaze_spawn_egg": "Bajda Sawrana tan-Najjar",
  "item.minecraft.blue_bundle": "Sorra Blu",
  "item.minecraft.blue_dye": "Żebgħa Blu",
  "item.minecraft.blue_egg": "Bajda Blu",
  "item.minecraft.blue_harness": "Xedd Blu",
  "item.minecraft.bogged_spawn_egg": "Bajda Sawrana tal-Mgħaddar",
  "item.minecraft.bolt_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Raqma Żilżla",
  "item.minecraft.bone": "Għadma",
  "item.minecraft.bone_meal": "Fertilizzant",
  "item.minecraft.book": "Ktieb",
  "item.minecraft.bordure_indented_banner_pattern": "Disinn tal-Bordura Mdaħħla",
  "item.minecraft.bow": "Qaws",
  "item.minecraft.bowl": "Skutella",
  "item.minecraft.bread": "Ħobż",
  "item.minecraft.breeze_rod": "Virga taż-Żiffief",
  "item.minecraft.breeze_spawn_egg": "Bajda Sawrana taż-Żiffief",
  "item.minecraft.brewer_pottery_shard": "Xaqqufa b’Flixkun",
  "item.minecraft.brewer_pottery_sherd": "Xaqqufa b’Flixkun",
  "item.minecraft.brewing_stand": "Birrerija",
  "item.minecraft.brick": "Briksa",
  "item.minecraft.brown_bundle": "Sorra Kannella",
  "item.minecraft.brown_dye": "Żebgħa Kannella",
  "item.minecraft.brown_egg": "Bajda Kannella",
  "item.minecraft.brown_harness": "Xedd Kannella",
  "item.minecraft.brush": "Pinzell",
  "item.minecraft.bucket": "Barmil",
  "item.minecraft.bundle": "Gozz",
  "item.minecraft.bundle.empty": "Vojta",
  "item.minecraft.bundle.empty.description": "Tista’ żżomm munzell ta’ oġġetti mħallta",
  "item.minecraft.bundle.full": "Mimlija",
  "item.minecraft.bundle.fullness": "%s minn %s",
  "item.minecraft.burn_pottery_shard": "Xaqqufa b’Nar",
  "item.minecraft.burn_pottery_sherd": "Xaqqufa b’Nar",
  "item.minecraft.camel_husk_spawn_egg": "Bajda Sawrana tal-Ġemel Minxuf",
  "item.minecraft.camel_spawn_egg": "Bajda Sawrana tal-Ġemel",
  "item.minecraft.carrot": "Karrotta",
  "item.minecraft.carrot_on_a_stick": "Karrotta fuq Stikka",
  "item.minecraft.cat_spawn_egg": "Bajda Sawrana tal-Qattus",
  "item.minecraft.cauldron": "Kaldarun",
  "item.minecraft.cave_spider_spawn_egg": "Bajda Sawrana tal-Brimba tal-Għar",
  "item.minecraft.chainmail_boots": "Stivali tal-Katina",
  "item.minecraft.chainmail_chestplate": "Korazza tal-Katina",
  "item.minecraft.chainmail_helmet": "Elmu tal-Katina",
  "item.minecraft.chainmail_leggings": "Getti tal-Katina",
  "item.minecraft.charcoal": "Faħam tal-Injam",
  "item.minecraft.cherry_boat": "Dgħajsa taċ-Ċirasa",
  "item.minecraft.cherry_chest_boat": "Dgħajsa taċ-Ċirasa b'Senduq",
  "item.minecraft.chest_minecart": "Karretta b'Senduq",
  "item.minecraft.chicken": "Tiġieġa Nejja",
  "item.minecraft.chicken_spawn_egg": "Bajda Sawrana tat-Tiġieġ",
  "item.minecraft.chorus_fruit": "Frotta tal-Chorus",
  "item.minecraft.clay_ball": "Ballun Tafal",
  "item.minecraft.clock": "Arloġġ",
  "item.minecraft.coal": "Faħam",
  "item.minecraft.coast_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Raqma Xatt",
  "item.minecraft.cocoa_beans": "Fażola tal-Kawkaw",
  "item.minecraft.cod": "Merluzz Nej",
  "item.minecraft.cod_bucket": "Barmil tal-Merluzz",
  "item.minecraft.cod_spawn_egg": "Bajda Sawrana tal-Merluzz",
  "item.minecraft.command_block_minecart": "Karretta bi Blokka tal-Kodiċi",
  "item.minecraft.compass": "Boxla",
  "item.minecraft.cooked_beef": "Ċanga Msajra",
  "item.minecraft.cooked_chicken": "Tiġieġa Msajra",
  "item.minecraft.cooked_cod": "Merluzz Imsajjar",
  "item.minecraft.cooked_mutton": "Laħam tan-Nagħġa Msajjar",
  "item.minecraft.cooked_porkchop": "Majjal Imsajjar",
  "item.minecraft.cooked_rabbit": "Fenek Imsajjar",
  "item.minecraft.cooked_salmon": "Salamun Imsajjar",
  "item.minecraft.cookie": "Gallettina",
  "item.minecraft.copper_axe": "Mannara tar-Ram",
  "item.minecraft.copper_boots": "Stivali tar-Ram",
  "item.minecraft.copper_chestplate": "Korazza tar-Ram",
  "item.minecraft.copper_golem_spawn_egg": "Bajda Sawrana tal-Ġgantin tar-Ram",
  "item.minecraft.copper_helmet": "Elmu tar-Ram",
  "item.minecraft.copper_hoe": "Mgħażqa tar-Ram",
  "item.minecraft.copper_horse_armor": "Bardatura tar-Ram",
  "item.minecraft.copper_ingot": "Ingotta tar-ram",
  "item.minecraft.copper_leggings": "Getti tar-Ram",
  "item.minecraft.copper_nautilus_armor": "Armatura tan-Nawtlu tar-Ram",
  "item.minecraft.copper_nugget": "Farka tar-Ram",
  "item.minecraft.copper_pickaxe": "Baqqun tar-Ram",
  "item.minecraft.copper_shovel": "Pala tar-Ram",
  "item.minecraft.copper_spear": "Lanza tar-Ram",
  "item.minecraft.copper_sword": "Xabla tar-Ram",
  "item.minecraft.cow_spawn_egg": "Bajda Sawrana tal-Baqra",
  "item.minecraft.creaking_spawn_egg": "Bajda Sawrana taż-Żaqżieq",
  "item.minecraft.creeper_banner_pattern": "Disinn",
  "item.minecraft.creeper_banner_pattern.desc": "Karga Kaxkiera",
  "item.minecraft.creeper_banner_pattern.new": "Disinn Kaxkier",
  "item.minecraft.creeper_spawn_egg": "Bajda Sawrana tal-Kaxkier",
  "item.minecraft.crossbow": "Qaws Mindud",
  "item.minecraft.crossbow.projectile": "Tajra:",
  "item.minecraft.crossbow.projectile.multiple": "Tajra: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Tajra: %s",
  "item.minecraft.cyan_bundle": "Sorra Żerqa",
  "item.minecraft.cyan_dye": "Żebgħa Blu fl-Aħdar",
  "item.minecraft.cyan_harness": "Xedd Iżraq",
  "item.minecraft.danger_pottery_shard": "Xaqqufa b’Kaxkier",
  "item.minecraft.danger_pottery_sherd": "Xaqqufa b’Kaxkier",
  "item.minecraft.dark_oak_boat": "Dgħajsa tal-Ballut Skur",
  "item.minecraft.dark_oak_chest_boat": "Dgħajsa tal-Ballut Dagħmi b'Senduq",
  "item.minecraft.debug_stick": "Stikka tal-Korreġiment",
  "item.minecraft.debug_stick.empty": "%s m'għandux proprjetajiet",
  "item.minecraft.debug_stick.select": "għażilt \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" għal %s",
  "item.minecraft.diamond": "Djamant",
  "item.minecraft.diamond_axe": "Mannara tad-Djamant",
  "item.minecraft.diamond_boots": "Żraben tad-Djamant",
  "item.minecraft.diamond_chestplate": "Armar tad-Djamant",
  "item.minecraft.diamond_helmet": "Elum tad-Djamant",
  "item.minecraft.diamond_hoe": "Mgħażqa tad-Djamant",
  "item.minecraft.diamond_horse_armor": "Armar taż-Żwiemel tad-Djamant",
  "item.minecraft.diamond_leggings": "Saqajn tad-Djamant",
  "item.minecraft.diamond_nautilus_armor": "Armatura tan-Nawtlu tad-Djamant",
  "item.minecraft.diamond_pickaxe": "Baqqun tad-Djamant",
  "item.minecraft.diamond_shovel": "Pala tad-Djamant",
  "item.minecraft.diamond_spear": "Lanza tad-Djamant",
  "item.minecraft.diamond_sword": "Xabla tad-Djamant",
  "item.minecraft.disc_fragment_5": "Biċċa tad-Diska",
  "item.minecraft.disc_fragment_5.desc": "Disket id-Daqq - 5",
  "item.minecraft.dolphin_spawn_egg": "Bajda Sawrana tad-Denfil",
  "item.minecraft.donkey_spawn_egg": "Bajda Sawrana tal-Ħmar",
  "item.minecraft.dragon_breath": "Nifs ta' Dragun",
  "item.minecraft.dried_kelp": "Alka Mnixxfa",
  "item.minecraft.drowned_spawn_egg": "Bajda Sawrana tal-Mgħerreq",
  "item.minecraft.dune_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Raqma Għarma",
  "item.minecraft.echo_shard": "Biċċa Diewja",
  "item.minecraft.egg": "Bajda",
  "item.minecraft.elder_guardian_spawn_egg": "Bajda Sawrana tal-Gwardjan Anzjan",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Żmerald",
  "item.minecraft.enchanted_book": "Ktieb Maġiku",
  "item.minecraft.enchanted_golden_apple": "Tuffieħa Dehbija Msaħħra",
  "item.minecraft.end_crystal": "Kristall tal-Ender",
  "item.minecraft.ender_dragon_spawn_egg": "Bajda Sawrana tad-Dragun Temmiem",
  "item.minecraft.ender_eye": "Għajn tal-Ender",
  "item.minecraft.ender_pearl": "Perla tal-Ender",
  "item.minecraft.enderman_spawn_egg": "Bajda Sawrana tal-Ħarries",
  "item.minecraft.endermite_spawn_egg": "Bajda Sawrana tal-Dwejda",
  "item.minecraft.evoker_spawn_egg": "Bajda Sawrana tal-Sejjieħ",
  "item.minecraft.experience_bottle": "Flixkun tal-Maġija",
  "item.minecraft.explorer_pottery_shard": "Xaqqufa b’Mappa",
  "item.minecraft.explorer_pottery_sherd": "Xaqqufa b’Mappa",
  "item.minecraft.eye_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Raqma Għajn",
  "item.minecraft.feather": "Rixa",
  "item.minecraft.fermented_spider_eye": "Għajn ta' Brimba Ffermentata",
  "item.minecraft.field_masoned_banner_pattern": "Disinn Briks",
  "item.minecraft.filled_map": "Mappa",
  "item.minecraft.fire_charge": "Balma tan-Nar",
  "item.minecraft.firework_rocket": "Murtal",
  "item.minecraft.firework_rocket.flight": "Dewm fl-Arja:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Balma tal-Murtali",
  "item.minecraft.firework_star.black": "Iswed",
  "item.minecraft.firework_star.blue": "Blu",
  "item.minecraft.firework_star.brown": "Kannella",
  "item.minecraft.firework_star.custom_color": "Personalizzat",
  "item.minecraft.firework_star.cyan": "Blu fl-Aħdar",
  "item.minecraft.firework_star.fade_to": "Jinbidel għal",
  "item.minecraft.firework_star.flicker": "Ileqq",
  "item.minecraft.firework_star.gray": "Griż",
  "item.minecraft.firework_star.green": "Aħdar",
  "item.minecraft.firework_star.light_blue": "Blu Ċar",
  "item.minecraft.firework_star.light_gray": "Griż Ċar",
  "item.minecraft.firework_star.lime": "Aħdar Ċar",
  "item.minecraft.firework_star.magenta": "Vjola Ċar",
  "item.minecraft.firework_star.orange": "Oranġjo",
  "item.minecraft.firework_star.pink": "Roża",
  "item.minecraft.firework_star.purple": "Vjola",
  "item.minecraft.firework_star.red": "Aħmar",
  "item.minecraft.firework_star.shape": "Forma Oħra",
  "item.minecraft.firework_star.shape.burst": "Tifqigħ",
  "item.minecraft.firework_star.shape.creeper": "Forma ta' Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Balma Kbira",
  "item.minecraft.firework_star.shape.small_ball": "Balma Żgħira",
  "item.minecraft.firework_star.shape.star": "Forma ta' Stilla",
  "item.minecraft.firework_star.trail": "Traċċa",
  "item.minecraft.firework_star.white": "Abjad",
  "item.minecraft.firework_star.yellow": "Isfar",
  "item.minecraft.fishing_rod": "Qasba tas-Sajd",
  "item.minecraft.flint": "Żnied",
  "item.minecraft.flint_and_steel": "Żnied u Ħadida",
  "item.minecraft.flow_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Raqma Fluss",
  "item.minecraft.flow_banner_pattern": "Disinn",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Disinn Fluss",
  "item.minecraft.flow_pottery_sherd": "Xaqqufa b’Fluss",
  "item.minecraft.flower_banner_pattern": "Disinn",
  "item.minecraft.flower_banner_pattern.desc": "Karg Żahri",
  "item.minecraft.flower_banner_pattern.new": "Disinn Żahri",
  "item.minecraft.flower_pot": "Qasrija",
  "item.minecraft.fox_spawn_egg": "Bajda Sawrana tal-Volpi",
  "item.minecraft.friend_pottery_shard": "Xaqqufa b’Ħabib",
  "item.minecraft.friend_pottery_sherd": "Xaqqufa b’Ħabib",
  "item.minecraft.frog_spawn_egg": "Bajda Sawrana taż-Żrinġ",
  "item.minecraft.furnace_minecart": "Karretta b'Forn",
  "item.minecraft.ghast_spawn_egg": "Bajda Sawrana tal-Waħħax",
  "item.minecraft.ghast_tear": "Demgħa ta' Ghast",
  "item.minecraft.glass_bottle": "Flixkun tal-Ħġieġ",
  "item.minecraft.glistering_melon_slice": "Biċċa Bettieħa Mleqqa",
  "item.minecraft.globe_banner_pattern": "Disinn",
  "item.minecraft.globe_banner_pattern.desc": "Dinja",
  "item.minecraft.globe_banner_pattern.new": "Disinn Globu",
  "item.minecraft.glow_berries": "Frott Lelliexi",
  "item.minecraft.glow_ink_sac": "Sakka Lelliexa",
  "item.minecraft.glow_item_frame": "Qafas Lelliexi",
  "item.minecraft.glow_squid_spawn_egg": "Bajda Sawrana tal-Klamar Lelliexi",
  "item.minecraft.glowstone_dust": "Trab tal-Ġebel Jixgħel",
  "item.minecraft.goat_horn": "Qarn tal-Mogħoż",
  "item.minecraft.goat_spawn_egg": "Bajda Sawrana tal-Mogħża",
  "item.minecraft.gold_ingot": "Ingott tad-Deheb",
  "item.minecraft.gold_nugget": "Farka tad-Deheb",
  "item.minecraft.golden_apple": "Tuffieħa tad-Deheb",
  "item.minecraft.golden_axe": "Mannara tad-Deheb",
  "item.minecraft.golden_boots": "Żraben tad-Deheb",
  "item.minecraft.golden_carrot": "Karrotta tad-Deheb",
  "item.minecraft.golden_chestplate": "Armar tad-Deheb",
  "item.minecraft.golden_helmet": "Elum tad-Deheb",
  "item.minecraft.golden_hoe": "Mgħażqa tad-Deheb",
  "item.minecraft.golden_horse_armor": "Bardatura tad-Deheb",
  "item.minecraft.golden_leggings": "Saqajn tad-Deheb",
  "item.minecraft.golden_nautilus_armor": "Armatura tan-Nawtlu tad-Deheb",
  "item.minecraft.golden_pickaxe": "Baqqun tad-Deheb",
  "item.minecraft.golden_shovel": "Pala tad-Deheb",
  "item.minecraft.golden_spear": "Lanza tad-Deheb",
  "item.minecraft.golden_sword": "Xabla tad-Deheb",
  "item.minecraft.gray_bundle": "Sorra Griża",
  "item.minecraft.gray_dye": "Żebgħa Griża",
  "item.minecraft.gray_harness": "Xedd Griż",
  "item.minecraft.green_bundle": "Sorra Ħadra",
  "item.minecraft.green_dye": "Żebgħa Ħadra",
  "item.minecraft.green_harness": "Xedd Aħdar",
  "item.minecraft.guardian_spawn_egg": "Bawda Sawrana tal-Gwardjan",
  "item.minecraft.gunpowder": "Porvli",
  "item.minecraft.guster_banner_pattern": "Disinn",
  "item.minecraft.guster_banner_pattern.desc": "Buffura",
  "item.minecraft.guster_banner_pattern.new": "Disinn Buffura",
  "item.minecraft.guster_pottery_sherd": "Xaqqufa b’Buffura",
  "item.minecraft.happy_ghast_spawn_egg": "Bajda Sawrana tal-Waħħax Ferħan",
  "item.minecraft.harness": "Xedd",
  "item.minecraft.heart_of_the_sea": "Qalbet il-Baħar",
  "item.minecraft.heart_pottery_shard": "Xaqqufa b’Qalb",
  "item.minecraft.heart_pottery_sherd": "Xaqqufa b’Qalb",
  "item.minecraft.heartbreak_pottery_shard": "Xaqqufa b’Qalb Miksura",
  "item.minecraft.heartbreak_pottery_sherd": "Xaqqufa b’Qalb Miksura",
  "item.minecraft.hoglin_spawn_egg": "Bajda Sawrana tal-Majjalu",
  "item.minecraft.honey_bottle": "Flixkun Għasel",
  "item.minecraft.honeycomb": "Xehda",
  "item.minecraft.hopper_minecart": "Karretta b'Lembut",
  "item.minecraft.horse_spawn_egg": "Bajd Sawrana taż-Żiemel",
  "item.minecraft.host_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.host_armor_trim_smithing_template.new": "Raqma Ospitant",
  "item.minecraft.howl_pottery_shard": "Xaqqufa b’Lupu",
  "item.minecraft.howl_pottery_sherd": "Xaqqufa b’Lupu",
  "item.minecraft.husk_spawn_egg": "Bajda Sawrana tal-Minxef",
  "item.minecraft.ink_sac": "Inka",
  "item.minecraft.iron_axe": "Mannara tal-Ħadid",
  "item.minecraft.iron_boots": "Żraben tal-Ħadid",
  "item.minecraft.iron_chestplate": "Armar tal-Ħadid",
  "item.minecraft.iron_golem_spawn_egg": "Bajda Sawrana tal-Ġgant tal-Ħadid",
  "item.minecraft.iron_helmet": "Elmu tal-Ħadid",
  "item.minecraft.iron_hoe": "Mgħażqa tal-Ħadid",
  "item.minecraft.iron_horse_armor": "Armar taż-Żwiemel tal-Ħadid",
  "item.minecraft.iron_ingot": "Ingott tal-Ħadid",
  "item.minecraft.iron_leggings": "Saqajn tal-Ħadid",
  "item.minecraft.iron_nautilus_armor": "Armatura tan-Nawtlu tal-Ħadid",
  "item.minecraft.iron_nugget": "Farka tal-Ħadid",
  "item.minecraft.iron_pickaxe": "Baqqun tal-Ħadid",
  "item.minecraft.iron_shovel": "Pala tal-Ħadid",
  "item.minecraft.iron_spear": "Lanza tal-Ħadid",
  "item.minecraft.iron_sword": "Xabla tal-Ħadid",
  "item.minecraft.item_frame": "Inkwatru",
  "item.minecraft.jungle_boat": "Dgħajsa tal-Injam tal-Ġungla",
  "item.minecraft.jungle_chest_boat": "Dgħajsa tal-Ġungla b'Senduq",
  "item.minecraft.knowledge_book": "Ktieb l-Għarfien",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Barmil Lava",
  "item.minecraft.lead": "Ċinga",
  "item.minecraft.leather": "Ġilda",
  "item.minecraft.leather_boots": "Żraben tal-Ġilda",
  "item.minecraft.leather_chestplate": "Flokk tal-Ġilda",
  "item.minecraft.leather_helmet": "Kappa tal-Ġilda",
  "item.minecraft.leather_horse_armor": "Bardatura tal-Ġilda",
  "item.minecraft.leather_leggings": "Qalziet tal-Ġilda",
  "item.minecraft.light_blue_bundle": "Sorra Kaħla",
  "item.minecraft.light_blue_dye": "Żebgħa Blu Ċara",
  "item.minecraft.light_blue_harness": "Xedd Ikħal",
  "item.minecraft.light_gray_bundle": "Sorra Xehba",
  "item.minecraft.light_gray_dye": "Żebgħa Griża Ċara",
  "item.minecraft.light_gray_harness": "Xedd Ixheb",
  "item.minecraft.lime_bundle": "Sorra Limetta",
  "item.minecraft.lime_dye": "Żebgħa Ħadra Ċara",
  "item.minecraft.lime_harness": "Xedd Limett",
  "item.minecraft.lingering_potion": "Taħlita Dewwiema",
  "item.minecraft.lingering_potion.effect.awkward": "Xarba Skomda Fumanti",
  "item.minecraft.lingering_potion.effect.empty": "Xarba Impossibbli Fumanti",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Xarba tar-Resistenza għan-Nar Fumanti",
  "item.minecraft.lingering_potion.effect.harming": "Xarba tal-Ħsara Fumanti",
  "item.minecraft.lingering_potion.effect.healing": "Xarba tal-Fejqan Fumanti",
  "item.minecraft.lingering_potion.effect.infested": "Taħlita Dewwiema tat-Tikmil",
  "item.minecraft.lingering_potion.effect.invisibility": "Xarba tal-Inviżibbiltaż Fumanti",
  "item.minecraft.lingering_potion.effect.leaping": "Xarba tal-Qbiż Fumanti",
  "item.minecraft.lingering_potion.effect.levitation": "Xarba tal-Levitazzjoni Fumanti",
  "item.minecraft.lingering_potion.effect.luck": "Xarba tal-Fortuna Fumanti",
  "item.minecraft.lingering_potion.effect.mundane": "Xarba Ordinarja Fumanti",
  "item.minecraft.lingering_potion.effect.night_vision": "Xarba tal-Viżjoni bil-Lejl Fumanti",
  "item.minecraft.lingering_potion.effect.oozing": "Taħlita Dewwiema tan-Nixa",
  "item.minecraft.lingering_potion.effect.poison": "Xarba tal-Velenu Fumanti",
  "item.minecraft.lingering_potion.effect.regeneration": "Xarba tar-Riġenerazzjoni Fumanti",
  "item.minecraft.lingering_potion.effect.slow_falling": "Taħlita Dewwiema tal-Uqigħ bil-Mod",
  "item.minecraft.lingering_potion.effect.slowness": "Xarba tad-Dewmien Fumanti",
  "item.minecraft.lingering_potion.effect.strength": "Xarba tal-Qawwa Fumanti",
  "item.minecraft.lingering_potion.effect.swiftness": "Xarba tal-Ħeffa Fumanti",
  "item.minecraft.lingering_potion.effect.thick": "Xarba Tqila Fumanti",
  "item.minecraft.lingering_potion.effect.turtle_master": "Taħlita Dewwiema ta' Kap il-Fkieren",
  "item.minecraft.lingering_potion.effect.water": "Flixkun Ilma Fumanti",
  "item.minecraft.lingering_potion.effect.water_breathing": "Xarba tan-Nifs Taħt l-Ilma Fumanti",
  "item.minecraft.lingering_potion.effect.weakness": "Xarba tad-Dgħjufija Fumanti",
  "item.minecraft.lingering_potion.effect.weaving": "Taħlita Dewwiema tal-Insiġ",
  "item.minecraft.lingering_potion.effect.wind_charged": " Taħlita Dewwiema tat-Tiżfif",
  "item.minecraft.llama_spawn_egg": "Bajda Sawrana tal-Llama",
  "item.minecraft.lodestone_compass": "Boxxla tal-Ġebletta",
  "item.minecraft.mace": "Mazza",
  "item.minecraft.magenta_bundle": "Sorra Maġenta",
  "item.minecraft.magenta_dye": "Żebgħa Vjola Ċara",
  "item.minecraft.magenta_harness": "Xedd Maġenta",
  "item.minecraft.magma_cream": "Krema tal-Magma",
  "item.minecraft.magma_cube_spawn_egg": "Bajda Sawrana tal-Kubu tal-Magma",
  "item.minecraft.mangrove_boat": "Dgħajsa tal-Mangrovja",
  "item.minecraft.mangrove_chest_boat": "Dgħajsa tal-Mangrovja b'Senduq",
  "item.minecraft.map": "Mappa Vojta",
  "item.minecraft.melon_seeds": "Żerriegħa tad-Dulliegħ",
  "item.minecraft.melon_slice": "Biċċa Bettieħa",
  "item.minecraft.milk_bucket": "Barmil Ħalib",
  "item.minecraft.minecart": "Karretta",
  "item.minecraft.miner_pottery_shard": "Xaqqufa b’Baqqun",
  "item.minecraft.miner_pottery_sherd": "Xaqqufa b’Baqqun",
  "item.minecraft.mojang_banner_pattern": "Disinn",
  "item.minecraft.mojang_banner_pattern.desc": "Ħaġa",
  "item.minecraft.mojang_banner_pattern.new": "Disinn Ħaġa",
  "item.minecraft.mooshroom_spawn_egg": "Bajda Sawrana tal-Fqajqa",
  "item.minecraft.mourner_pottery_shard": "Xaqqufa b’Imnikket",
  "item.minecraft.mourner_pottery_sherd": "Xaqqufa b’Imnikket",
  "item.minecraft.mule_spawn_egg": "Bajda Sawrana tal-Bagħal",
  "item.minecraft.mushroom_stew": "Stuffat tal-Faqqiegħ",
  "item.minecraft.music_disc_11": "Disket id-Daqq",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Diska tal-Mużika",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disket id-Daqq",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disket id-Daqq",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disket id-Daqq",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disket id-Daqq",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disket id-Daqq",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disket id-Daqq",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Disket id-Daqq",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disket id-Daqq",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disket id-Daqq",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disket id-Daqq",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disket id-Daqq",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - Otherside",
  "item.minecraft.music_disc_pigstep": "Disket id-Daqq",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disket id-Daqq",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disket id-Daqq",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Disket id-Daqq",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disket id-Daqq",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disket id-Daqq",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disket id-Daqq",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disket id-Daqq",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Laħam tan-Nagħġa Nej",
  "item.minecraft.name_tag": "Tikketta",
  "item.minecraft.nautilus_shell": "Qoxra tan-Nawtlu",
  "item.minecraft.nautilus_spawn_egg": "Bajda Sawrana tan-Nawtlu",
  "item.minecraft.nether_brick": "Briks tan-Nether",
  "item.minecraft.nether_star": "Stilla tan-Nether",
  "item.minecraft.nether_wart": "Faqqiegħ Taħħat",
  "item.minecraft.netherite_axe": "Mannara tan-Matħat",
  "item.minecraft.netherite_boots": "Stivali tal-Matħat",
  "item.minecraft.netherite_chestplate": "Korazza tal-Matħat",
  "item.minecraft.netherite_helmet": "Elmu tal-Matħat",
  "item.minecraft.netherite_hoe": "Mgħażqa tan-Netherajt",
  "item.minecraft.netherite_horse_armor": "Bardatura tal-Matħat",
  "item.minecraft.netherite_ingot": "Ingott tal-Matħat",
  "item.minecraft.netherite_leggings": "Getti tal-Matħat",
  "item.minecraft.netherite_nautilus_armor": "Armatura tan-Nawtlu tal-Matħat",
  "item.minecraft.netherite_pickaxe": "Baqqun tal-Matħat",
  "item.minecraft.netherite_scrap": "Laqxa tal-Matħat",
  "item.minecraft.netherite_shovel": "Pala tal-Matħat",
  "item.minecraft.netherite_spear": "Lanza tal-Matħat",
  "item.minecraft.netherite_sword": "Xabla tal-Matħat",
  "item.minecraft.netherite_upgrade_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Aġġornament Matħat",
  "item.minecraft.oak_boat": "Dgħajsa tal-Ballut",
  "item.minecraft.oak_chest_boat": "Dgħajsa tal-Ballut b'Senduq",
  "item.minecraft.ocelot_spawn_egg": "Bajda Sawrana tal-Oċelot",
  "item.minecraft.ominous_bottle": "Flixkun Awgurju",
  "item.minecraft.ominous_trial_key": "Muftieħ il-Ġarb Awgurju",
  "item.minecraft.orange_bundle": "Sorra Oranġjo",
  "item.minecraft.orange_dye": "Żebgħa Oranġjo",
  "item.minecraft.orange_harness": "Xedd Oranġjo",
  "item.minecraft.painting": "Pittura",
  "item.minecraft.pale_oak_boat": "Dgħajsa tal-Ballut Bajdan",
  "item.minecraft.pale_oak_chest_boat": "Dgħajsa tal-Ballut Bajdan b'Senduq",
  "item.minecraft.panda_spawn_egg": "Bajda Sawrana tal-Panda",
  "item.minecraft.paper": "Karta",
  "item.minecraft.parched_spawn_egg": "Bajda Sawrana tal-Għatxan",
  "item.minecraft.parrot_spawn_egg": "Bajda Sawrana tal-Pappagall",
  "item.minecraft.phantom_membrane": "Tertuqa tal-Fantażma",
  "item.minecraft.phantom_spawn_egg": "Bajda Sawrana tal-Fantażma",
  "item.minecraft.pig_spawn_egg": "Bajda Sawrana tal-Ħanżir",
  "item.minecraft.piglin_banner_pattern": "Disinn",
  "item.minecraft.piglin_banner_pattern.desc": "Imnieħer",
  "item.minecraft.piglin_banner_pattern.new": "Disinn Imnieħer",
  "item.minecraft.piglin_brute_spawn_egg": "Bajda Sawrana tal-Ħnejżer Bhima",
  "item.minecraft.piglin_spawn_egg": "Bajda Sawrana tal-Ħnejżer",
  "item.minecraft.pillager_spawn_egg": "Bajda Sawrana tax-Xarrak",
  "item.minecraft.pink_bundle": "Sorra Roża",
  "item.minecraft.pink_dye": "Żebgħa Roża",
  "item.minecraft.pink_harness": "Xedd Roża",
  "item.minecraft.pitcher_plant": "Buqxtiela",
  "item.minecraft.pitcher_pod": "Miżwed il-Buqxtiela",
  "item.minecraft.plenty_pottery_shard": "Xaqqufa b’Teżor",
  "item.minecraft.plenty_pottery_sherd": "Xaqqufa b’Teżor",
  "item.minecraft.poisonous_potato": "Patata Velenuża",
  "item.minecraft.polar_bear_spawn_egg": "Bajda Sawrana tal-Ors Polari",
  "item.minecraft.popped_chorus_fruit": "Frotta tal-Chorus Mifqugħha",
  "item.minecraft.porkchop": "Majjal Nej",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Xarba",
  "item.minecraft.potion.effect.awkward": "Xarba Skomda",
  "item.minecraft.potion.effect.empty": "Xarba Impossibbli",
  "item.minecraft.potion.effect.fire_resistance": "Xarba tar-Reżistenza għan-Nar",
  "item.minecraft.potion.effect.harming": "Xarba tal-Ħsara",
  "item.minecraft.potion.effect.healing": "Xarba tal-Fejqan",
  "item.minecraft.potion.effect.infested": "Taħlita tat-Tikmil",
  "item.minecraft.potion.effect.invisibility": "Xarba tal-Inviżibbilta'",
  "item.minecraft.potion.effect.leaping": "Xarba tal-Qbiż",
  "item.minecraft.potion.effect.levitation": "Potion ta ' Levitazzjoni",
  "item.minecraft.potion.effect.luck": "Xarba tal-Fortuna",
  "item.minecraft.potion.effect.mundane": "Xarba Ordinarja",
  "item.minecraft.potion.effect.night_vision": "Xarba tal-Viżjoni fid-Dlam",
  "item.minecraft.potion.effect.oozing": "Taħlita tan-Nixa",
  "item.minecraft.potion.effect.poison": "Xarba tal-Velenu",
  "item.minecraft.potion.effect.regeneration": "Xarba tar-Riġenerazzjoni",
  "item.minecraft.potion.effect.slow_falling": "Taħlita tal-Uqigħ bil-Mod",
  "item.minecraft.potion.effect.slowness": "Xarba tad-Dewmien",
  "item.minecraft.potion.effect.strength": "Xarba tal-Qawwa",
  "item.minecraft.potion.effect.swiftness": "Xarba tal-Ħeffa",
  "item.minecraft.potion.effect.thick": "Xarba Tqila",
  "item.minecraft.potion.effect.turtle_master": "Taħlita tal-Kap il-Fkieren",
  "item.minecraft.potion.effect.water": "Flixkun tal-Ilma",
  "item.minecraft.potion.effect.water_breathing": "Xarba tan-Nifs Taħt l-Ilma",
  "item.minecraft.potion.effect.weakness": "Xarba tad-Dgħjufija",
  "item.minecraft.potion.effect.weaving": "Taħlita tal-Insiġ",
  "item.minecraft.potion.effect.wind_charged": "Taħlita tat-Tiżfif",
  "item.minecraft.pottery_shard_archer": "Xaqqufa b’Qaws",
  "item.minecraft.pottery_shard_arms_up": "Xaqqufa b’Dirgħajn ‘il Fuq",
  "item.minecraft.pottery_shard_prize": "Xaqqufa b’Premju",
  "item.minecraft.pottery_shard_skull": "Xaqqufa b’Kranju",
  "item.minecraft.powder_snow_bucket": "Barmil tal-Borra Mtarrab",
  "item.minecraft.prismarine_crystals": "Kristalli tal-Prismarine",
  "item.minecraft.prismarine_shard": "Farka tal-Prismarine",
  "item.minecraft.prize_pottery_shard": "Xaqqufa b’Premju",
  "item.minecraft.prize_pottery_sherd": "Xaqqufa b’Premju",
  "item.minecraft.pufferfish": "Ħuta Velenuża",
  "item.minecraft.pufferfish_bucket": "Barmil b'Minfaħ",
  "item.minecraft.pufferfish_spawn_egg": "Bajda Sawrana tal-Minfaħ",
  "item.minecraft.pumpkin_pie": "Torta tal-Qargħa Ħamra",
  "item.minecraft.pumpkin_seeds": "Żerriegħa tal-Qargħa Ħamra",
  "item.minecraft.purple_bundle": "Sorra Vjola",
  "item.minecraft.purple_dye": "Żebgħa Vjola",
  "item.minecraft.purple_harness": "Xedd Vjola",
  "item.minecraft.quartz": "Kwarz tan-Nether",
  "item.minecraft.rabbit": "Fenek Nej",
  "item.minecraft.rabbit_foot": "Sieq il-Fenek",
  "item.minecraft.rabbit_hide": "Ġilda tal-Fenek",
  "item.minecraft.rabbit_spawn_egg": "Bajda Sawrana tal-Fenek",
  "item.minecraft.rabbit_stew": "Stuffat tal-Fenek",
  "item.minecraft.raiser_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raqma Għollej",
  "item.minecraft.ravager_spawn_egg": "Bajda Sawrana tal-Ħarrieb",
  "item.minecraft.raw_copper": "Ram Prim",
  "item.minecraft.raw_gold": "Deheb Prim",
  "item.minecraft.raw_iron": "Ħadid Prim",
  "item.minecraft.recovery_compass": "Boxxla tal-Irkupru",
  "item.minecraft.red_bundle": "Sorra Ħamra",
  "item.minecraft.red_dye": "Żebgħa Ħamra",
  "item.minecraft.red_harness": "Xedd Aħmar",
  "item.minecraft.redstone": "Trab tar-Redstone",
  "item.minecraft.resin_brick": "Briksa tar-Reżina",
  "item.minecraft.resin_clump": "Ċappa Reżina",
  "item.minecraft.rib_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Raqma Kustilja",
  "item.minecraft.rotten_flesh": "Laħam Maqtugħ",
  "item.minecraft.saddle": "Sarġ",
  "item.minecraft.salmon": "Salamun Nej",
  "item.minecraft.salmon_bucket": "Barmil b'Salamun",
  "item.minecraft.salmon_spawn_egg": "Bajda Sawrana tas-Salamun",
  "item.minecraft.scrape_pottery_sherd": "Xaqqufa b’Mannara",
  "item.minecraft.scute": "Skuta",
  "item.minecraft.sentry_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Raqma Sentinella",
  "item.minecraft.shaper_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Raqma Fassal",
  "item.minecraft.sheaf_pottery_shard": "Xaqqufa b’Qatta",
  "item.minecraft.sheaf_pottery_sherd": "Xaqqufa b’Qatta",
  "item.minecraft.shears": "Ġliem",
  "item.minecraft.sheep_spawn_egg": "Bajda Sawrana tan-Nagħaġ",
  "item.minecraft.shelter_pottery_shard": "Xaqqufa b’Kenn",
  "item.minecraft.shelter_pottery_sherd": "Xaqqufa b’Kenn",
  "item.minecraft.shield": "Tarka",
  "item.minecraft.shield.black": "Tarka Sewda",
  "item.minecraft.shield.blue": "Tarka Blu",
  "item.minecraft.shield.brown": "Tarka Kannella",
  "item.minecraft.shield.cyan": "Tarka Żerqa",
  "item.minecraft.shield.gray": "Tarka Griża",
  "item.minecraft.shield.green": "Tarka Ħadra",
  "item.minecraft.shield.light_blue": "Tarka Kaħla",
  "item.minecraft.shield.light_gray": "Tarka Xehba",
  "item.minecraft.shield.lime": "Tarka Limetta",
  "item.minecraft.shield.magenta": "Tarka Maġenta",
  "item.minecraft.shield.orange": "Tarka Oranġjo",
  "item.minecraft.shield.pink": "Tarka Roża",
  "item.minecraft.shield.purple": "Tarka Vjola",
  "item.minecraft.shield.red": "Tarka Ħamra",
  "item.minecraft.shield.white": "Tarka Bajda",
  "item.minecraft.shield.yellow": "Tarka Safra",
  "item.minecraft.shulker_shell": "Qoxra Qoxrana",
  "item.minecraft.shulker_spawn_egg": "Bajda Sawrana tal-Qoxran",
  "item.minecraft.sign": "Tabella",
  "item.minecraft.silence_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Raqma Skiet",
  "item.minecraft.silverfish_spawn_egg": "Bajda Sawrana tal-Kamla",
  "item.minecraft.skeleton_horse_spawn_egg": "Bajda Sawrana taż-Żiemel Skeletru",
  "item.minecraft.skeleton_spawn_egg": "Bajda Sawrana tal-Iskeletru",
  "item.minecraft.skull_banner_pattern": "Disinn",
  "item.minecraft.skull_banner_pattern.desc": "Kranju",
  "item.minecraft.skull_banner_pattern.new": "Disinn Kranju",
  "item.minecraft.skull_pottery_shard": "Xaqqufa b’Kranju",
  "item.minecraft.skull_pottery_sherd": "Xaqqufa b’Kranju",
  "item.minecraft.slime_ball": "Ballun tal-Ħama",
  "item.minecraft.slime_spawn_egg": "Bajda Sawrana tal-Ħama",
  "item.minecraft.smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.smithing_template.applies_to": "Japplika għal:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Żid ingott jew kristall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armatura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Żid biċċa armatura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingotti u Kristalli",
  "item.minecraft.smithing_template.ingredients": "Ingredjenti:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Żid Ingott tal-Matħat",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Tagħmir tad-Djamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Żid armatura, arma, jew għodda tad-djamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Ingott tal-Matħat",
  "item.minecraft.smithing_template.upgrade": "Aġġornament: ",
  "item.minecraft.sniffer_spawn_egg": "Bajda Sawrana tax-Xammiem",
  "item.minecraft.snort_pottery_shard": "Xaqqufa b’Xammiem",
  "item.minecraft.snort_pottery_sherd": "Xaqqufa b’Xammiem",
  "item.minecraft.snout_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Raqma Mnieħer",
  "item.minecraft.snow_golem_spawn_egg": "Bajda Sawrana tal-Ġgantin tal-Borra",
  "item.minecraft.snowball": "Ballun tas-Silġ",
  "item.minecraft.spectral_arrow": "Vleġġa Spettrali",
  "item.minecraft.spider_eye": "Għajn ta' Brimba",
  "item.minecraft.spider_spawn_egg": "Bajda Sawrana tal-Brimba",
  "item.minecraft.spire_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Raqma Spira",
  "item.minecraft.splash_potion": "Taħlita Xerrieda",
  "item.minecraft.splash_potion.effect.awkward": "Xarba Skomda Tinxtered",
  "item.minecraft.splash_potion.effect.empty": "Xarba Tinxtered Impossibbli",
  "item.minecraft.splash_potion.effect.fire_resistance": "Xarba tar-Resistenza għan-Nar Tinxtered",
  "item.minecraft.splash_potion.effect.harming": "Xarba tal-Ħsara Tinxtered",
  "item.minecraft.splash_potion.effect.healing": "Xarba tal-Fejqan Tinxtered",
  "item.minecraft.splash_potion.effect.infested": "Taħlita Xerrieda tat-Tikmil",
  "item.minecraft.splash_potion.effect.invisibility": "Xarba tal-Inviżibbilta' Tinxtered",
  "item.minecraft.splash_potion.effect.leaping": "Xarba tal-Qbiż Tinxtered",
  "item.minecraft.splash_potion.effect.levitation": "Xarba tal-Levitazzjoni Tinxtered",
  "item.minecraft.splash_potion.effect.luck": "Xarba tal-Fortuna Tinxtered",
  "item.minecraft.splash_potion.effect.mundane": "Xarba Ordinarja Tinxtered",
  "item.minecraft.splash_potion.effect.night_vision": "Xarba tal-Viżjoni fid-Dlam Tinxtered",
  "item.minecraft.splash_potion.effect.oozing": "Taħlita Xerrieda tan-Nixa",
  "item.minecraft.splash_potion.effect.poison": "Xarba tal-Velenu Tinxtered",
  "item.minecraft.splash_potion.effect.regeneration": "Xarba tar-Riġenerazzjoni Tinxtered",
  "item.minecraft.splash_potion.effect.slow_falling": "Taħlita Xerrieda tal-Uqigħ bil-Mod",
  "item.minecraft.splash_potion.effect.slowness": "Xarba tad-Dewmien Tinxtered",
  "item.minecraft.splash_potion.effect.strength": "Xarba tal-Qawwa Tinxtered",
  "item.minecraft.splash_potion.effect.swiftness": "Xarba tal-Ħeffa Tinxtered",
  "item.minecraft.splash_potion.effect.thick": "Xarba Tqila Tinxtered",
  "item.minecraft.splash_potion.effect.turtle_master": "Taħlita Xerrieda tal-Kap il-Fkieren",
  "item.minecraft.splash_potion.effect.water": "Flixkun tal-Ilma Jinxtered",
  "item.minecraft.splash_potion.effect.water_breathing": "Xarba tan-Nifs Taħt l-Ilma Tinxtered",
  "item.minecraft.splash_potion.effect.weakness": "Xarba tad-Dgħjufija Tinxtered",
  "item.minecraft.splash_potion.effect.weaving": "Taħlita Xerrieda tal-Insiġ",
  "item.minecraft.splash_potion.effect.wind_charged": "Taħlita Xerrieda tat-Tiżfif",
  "item.minecraft.spruce_boat": "Dgħajsa tal-Arżnu",
  "item.minecraft.spruce_chest_boat": "Dgħajsa tal-Abit b'Senduq",
  "item.minecraft.spyglass": "Teleskopju",
  "item.minecraft.squid_spawn_egg": "Bajda Sawrana tal-Klamar",
  "item.minecraft.stick": "Stikka",
  "item.minecraft.stone_axe": "Mannara tal-Ġebel",
  "item.minecraft.stone_hoe": "Mgħażqa tal-Ġebel",
  "item.minecraft.stone_pickaxe": "Baqqun tal-Ġebel",
  "item.minecraft.stone_shovel": "Pala tal-Ġebel",
  "item.minecraft.stone_spear": "Lanza tal-Ġebel",
  "item.minecraft.stone_sword": "Xabla tal-Ġebel",
  "item.minecraft.stray_spawn_egg": "Bajda Sawrana tal-Imwarrab",
  "item.minecraft.strider_spawn_egg": "Bajda Sawrana tal-Passier",
  "item.minecraft.string": "Spaga",
  "item.minecraft.sugar": "Zokkor",
  "item.minecraft.suspicious_stew": "Stuffat Dubjuż",
  "item.minecraft.sweet_berries": "Frott Ħelu",
  "item.minecraft.tadpole_bucket": "Barmil tal-Marżepp",
  "item.minecraft.tadpole_spawn_egg": "Bajda Sawrana tal-Marżepp",
  "item.minecraft.tide_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Raqma Marea",
  "item.minecraft.tipped_arrow": "Vleġġa Miksija",
  "item.minecraft.tipped_arrow.effect.awkward": "Vleġġa Miksija",
  "item.minecraft.tipped_arrow.effect.empty": "Vleġġa Miksija Bla Sawran",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Vleġġa tar-Reżistenza għan-Nar",
  "item.minecraft.tipped_arrow.effect.harming": "Vleġġa tal-Ħsara",
  "item.minecraft.tipped_arrow.effect.healing": "Vleġġa tal-Fejqan",
  "item.minecraft.tipped_arrow.effect.infested": "Vleġġa tat-Tikmil",
  "item.minecraft.tipped_arrow.effect.invisibility": "Vleġġa tal-Inviżibbiltà",
  "item.minecraft.tipped_arrow.effect.leaping": "Vleġġa tal-Qbiż",
  "item.minecraft.tipped_arrow.effect.levitation": "Vleġġa tal-Levitazzjoni",
  "item.minecraft.tipped_arrow.effect.luck": "Vleġġa tal-Fortuna",
  "item.minecraft.tipped_arrow.effect.mundane": "Vleġġa Miksija",
  "item.minecraft.tipped_arrow.effect.night_vision": "Vleġġa tal-Viżjoni bil-Lejl",
  "item.minecraft.tipped_arrow.effect.oozing": "Vleġġa tan-Nixa",
  "item.minecraft.tipped_arrow.effect.poison": "Vleġġa tal-Velenu",
  "item.minecraft.tipped_arrow.effect.regeneration": "Vleġġa tar-Riġenerazzjoni",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Vleġġa tal-Uqigħ bil-Mogħod",
  "item.minecraft.tipped_arrow.effect.slowness": "Vleġġa tad-Dewmien",
  "item.minecraft.tipped_arrow.effect.strength": "Vleġġa tal-Qawwa",
  "item.minecraft.tipped_arrow.effect.swiftness": "Vleġġa tal-Ħeffa",
  "item.minecraft.tipped_arrow.effect.thick": "Vleġġa Miksija",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Vleġġa tal-Kap il-Fkieren",
  "item.minecraft.tipped_arrow.effect.water": "Vleġġa tat-Tixrid",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vleġġa tan-Nifs Taħt l-Ilma",
  "item.minecraft.tipped_arrow.effect.weakness": "Vleġġa tad-Dgħjufija",
  "item.minecraft.tipped_arrow.effect.weaving": "Vleġġa tal-Insiġ",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vleġġa tat-Tiżfif",
  "item.minecraft.tnt_minecart": "Karretta bl-Isplussivi",
  "item.minecraft.torchflower_seeds": "Żerriegħa tal-Fjurtorċa",
  "item.minecraft.totem_of_undying": "Totem tal-Immortalità",
  "item.minecraft.trader_llama_spawn_egg": "Bajda Sawrana tal-Llama Mmannas",
  "item.minecraft.trial_key": "Muftieħ il-Ġarb",
  "item.minecraft.trident": "Foxxna",
  "item.minecraft.tropical_fish": "Ħuta Tropikali",
  "item.minecraft.tropical_fish_bucket": "Barmil b'Ħuta Tropikali",
  "item.minecraft.tropical_fish_spawn_egg": "Bajda Sawrana tal-Ħut Tropikali",
  "item.minecraft.turtle_helmet": "Qoxra tal-Fekruna",
  "item.minecraft.turtle_scute": "Skuta tal-Fekruna",
  "item.minecraft.turtle_spawn_egg": "Bajda Sawrana tal-Fekruna",
  "item.minecraft.vex_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Raqma Dejjieq",
  "item.minecraft.vex_spawn_egg": "Bajda Sawrana tad-Dejjieq",
  "item.minecraft.villager_spawn_egg": "Bajda Sawrana tar-Raħħal",
  "item.minecraft.vindicator_spawn_egg": "Bajda Sawrana tal-Vindikatur",
  "item.minecraft.wandering_trader_spawn_egg": "Bajda Sawrana tan-Negozjant Merrieħi",
  "item.minecraft.ward_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Raqma Għassies",
  "item.minecraft.warden_spawn_egg": "Bajda Sawrana tal-Għassies",
  "item.minecraft.warped_fungus_on_a_stick": "Qasba b'Fungu Mgħawweġ",
  "item.minecraft.water_bucket": "Barmil Ilma",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Raqma Sejjieb",
  "item.minecraft.wheat": "Qamħ",
  "item.minecraft.wheat_seeds": "Żerriegħa tal-Qamħ",
  "item.minecraft.white_bundle": "Sorra Bajda",
  "item.minecraft.white_dye": "Żebgħa Bajda",
  "item.minecraft.white_harness": "Xedd Abjad",
  "item.minecraft.wild_armor_trim_smithing_template": "Mudell tal-Ħaddied",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Raqma Selvaġġ",
  "item.minecraft.wind_charge": "Żiffija",
  "item.minecraft.witch_spawn_egg": "Bajda Sawrana tas-Saħħara",
  "item.minecraft.wither_skeleton_spawn_egg": "Bajda Sawrana tal-Iskeletru Debbiel",
  "item.minecraft.wither_spawn_egg": "Bajda Sawrana tad-Debbiel",
  "item.minecraft.wolf_armor": "Armatura tal-Lupu",
  "item.minecraft.wolf_spawn_egg": "Bajda Sawrana tal-Lupu",
  "item.minecraft.wooden_axe": "Mannara tal-Injam",
  "item.minecraft.wooden_hoe": "Mgħażqa tal-Injam",
  "item.minecraft.wooden_pickaxe": "Baqqun tal-Injam",
  "item.minecraft.wooden_shovel": "Pala tal-Injam",
  "item.minecraft.wooden_spear": "Lanza tal-Injam",
  "item.minecraft.wooden_sword": "Xabla tal-Injam",
  "item.minecraft.writable_book": "Ktieb bir-Rixa",
  "item.minecraft.written_book": "Ktieb Miktub",
  "item.minecraft.yellow_bundle": "Sorra Safra",
  "item.minecraft.yellow_dye": "Żebgħa Safra",
  "item.minecraft.yellow_harness": "Xedd Isfar",
  "item.minecraft.zoglin_spawn_egg": "Bajda tal-Żmajjalu",
  "item.minecraft.zombie_horse_spawn_egg": "Bajd taż-Żiemel Żombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Bajda Sawrana taż-Żnawtlu",
  "item.minecraft.zombie_spawn_egg": "Bajda Sawrana taż-Żombi",
  "item.minecraft.zombie_villager_spawn_egg": "Bajda Sawrana tar-Żraħħal",
  "item.minecraft.zombified_piglin_spawn_egg": "Bajda tal-Żiħnejżer"
}
export const mt_mt = items; 
